const en_US = {
  // Shared Zone
  tag_name: 'Tag Name',
  property: 'Property',
  protocol: 'Protocol',
  endpoint: 'Endpoint',
  parameters: 'Parameters',
  items: '{item}s',
  delete_msg: 'Are you sure to delete this {item}?',
  this_field_is_required: 'This field is required',
  external_address: 'External Address',
  internal_address: 'Internal Address',
  port: 'Port',
  name_validate_error_msg: 'Only a-z, 0-9 . _ and - allowed',
  edit: 'Edit',
  name: 'Name',
  name_length_range: 'The name support {range} characters',
  description: 'Description',
  created_time: 'Created Time',
  status: 'Status',
  delete: 'Delete',
  cancel: 'Cancel',
  service_infos: 'Service Infos',
  generate_token: 'Generate Token',
  services_name: 'Services Name',
  Description: 'Description',
  expose_service_address: 'Expose Service Address',
  service_address: 'Service Address',
  enable_auto_delete: 'Enable Auto Delete',
  appgroup: 'App Group',
  config_description: 'Config Description',
  draft: 'Draft',
  release: 'Release',
  please_select_config: 'Please Select Config',
  roll_back: 'Roll Back',
  versionhistory: 'Version History',
  service_property: 'Service Property',
  workload_name: 'Workload Name',
  namespace_name: 'Namespace Name',
  cluster_name: 'Cluster Name',
  please_select_service: 'Please Select Service',
  skip: 'Skip',
  namespace: 'Namespace',
  cluster: 'Cluster',
  management: 'Management',
  console: 'Console',
  lang: 'Languages',
  catalog: 'Catalog',
  address: 'Address',
  alternative_email: 'Alternative Email',
  billing: 'Billing',
  city: 'City',
  company: 'Company',
  config: 'Config',
  confirm: 'Confirm',
  contact_phone: 'Contact Phone',
  contact_technical_support: 'Contact Technical Support',
  country_region: 'Country/Region',
  create: 'Create',
  create_time: 'Created Time',
  delete_role: 'Are you sure you want to delete this role?',
  delete_roles: 'Are you sure you want to delete those roles?',
  delete_user: 'Are you sure you want to delete {name}?',
  disabled: 'Disabled',
  delete_item: 'Delete {type}',
  enabled: 'Enabled',
  empty: 'Empty',
  first_name: 'First name',
  highest_role: 'Highest Role',
  home: 'Home',
  industry: 'Industry',
  invite: 'Invite',
  last_login: 'Last Login',
  last_name: 'Last name',
  license_invalid: 'Invalid license or license has expired',
  loading: 'Loading...',
  not_login: 'Not logged in yet',
  order: 'Order',
  path: 'Path',
  value: 'Value',
  overview: 'Overview',
  p_s_rc: 'Please select a country or region',
  quota: 'Quota',
  resources_mgmt: 'Resource management',
  resources_permission_exist: 'Resource permission already exists',
  role_permission_exist: 'Role permission already exists',
  resource_permissions_sub: 'Create, assign, and manage user resource permissions and roles',
  role: 'Role',
  rules: 'Rules',
  save: 'Save',
  select_role: 'Select a role',
  service: 'Service',
  services: 'Services',
  services_list:
    'Service Management includes: displaying the service list and details in each application group, service registration, whether the service address is exposed to the public service list and service health check.',
  success_save: 'Saved successfully',
  support_message: 'If you are experiencing issues and need technical support, please send an e-mail to',
  source: 'Source',
  stop: 'Stop',
  type: 'Type',
  user_base_info: 'Basic information of users',
  user_center: 'User Center',
  user_info: 'User Information',
  user_info_sub: 'Basic information and permissions of users',
  username: 'username',
  workspace: 'Workspace',
  resource: 'Resource',
  add: 'Add',
  events: 'Events',
  refresh: 'Refresh',
  remember_me: 'Remember me',
  search: 'Search',
  subscription_name: 'Subscription Name',
  total_items: 'Total {value} items',
  user: 'User',
  view: 'View',
  activation_code: 'Activation code',
  back: 'Back',
  bind: 'bind',
  bind_sso: 'Bind to EnSaaS SSO account',
  change: 'Change',
  change_pwd: 'Change password',
  change_pwd_sub: 'Change Password for first time login,Please reference Password characters.',
  confirm_info: '「Confirm」clicking confirm means that you agree to create SSO account',
  create_info:
    'We will generate a set of EnSaaS SSO accounts for you and bind them to your MyAdvantech Account. EnSaaS subscription number is bound to MyAdvantech Account. After binding, you will receive an EnSaaS SSO account registration letter, please log in EnSaaS Portal and change your password according to the instructions in the registration letter.',
  creation_time: 'Creation Time',
  delete_users: 'Are you sure you want to delete those users?',
  disable: 'Disable',
  disable_user: 'Are you sure you want to disable this user?',
  disable_users: 'Are you sure you want to disable these users?',
  enable: 'Enable',
  enable_user: 'Are you sure you want to enable this user?',
  enable_users: 'Are you sure you want to enable these users?',
  export: 'Export',
  help: 'Help',
  id: 'ID',
  member: 'Member',
  node_type: 'Node Type',
  or_sign_in_with: 'Or sign in with',
  origin: 'Origin',
  p_c_pwd: 'Please check password',
  p_i_password: 'Please enter password',
  p_i_phone: 'Please enter the phone number',
  p_i_n_pwd: 'Please enter new password',
  p_i_n_pwd_a: 'Please enter new password again',
  p_i_activation_code: 'Please enter activation code!',
  password_check_email: 'Please check the email and enter the correct password',
  password_error: 'Password Error',
  pwd_p_1: 'at least 8 characters',
  pwd_p_2: 'at least 1 digit',
  pwd_p_3: 'at least 1 lower case letter',
  pwd_p_4: 'at least 1 upper case letter',
  pwd_p_5: 'at least 1 special character',
  pwd_p_6: 'except space ( ), backslash (\\) and double quotes (")',
  pwd_policy: 'The password policy',
  retry: 'Retry',
  reset: 'Reset',
  reset_pwd_valid: 'Reset password code is valid',
  resend_code: 'resend code',
  resend_email: 'Resend Email',
  resend_email_sub: 'Enter Email to resend registration Email',
  resend_email_info:
    "If you don't receive registration Email after complete registration you can use this tool to resend it. Upon submission you will receive an Email with the link to complete the process.To resend registration Email, enter your username (Email), then click 'Submit'.",
  reset_pwd_success: 'Reset password successfully.',
  resend_email_success: 'Resend registration email successfully. Page will be redirecting after 5 seconds.',
  send_pwd_email_success: 'Send password reset Email successfully. Page will be redirecting after 5 seconds.',
  select_dc: 'Select a data center',
  select_cluster: 'Select a Cluster',
  select_ws: 'Select a workspace',
  select_ns: 'Select a namespace',
  setting: 'Setting',
  success: 'Success',
  submit: 'Submit',
  subscription: 'Subscription',
  subscription_info: 'Subscription Information',
  subscriptions: 'Subscriptions',
  system_notification_sub: 'For the first login, we recommend that you change the default password immediately.',
  two_pwd_unequal: 'Two passwords that you enter is inconsistent!',
  update: 'Update',
  user_id: 'User ID',
  username_email: 'Username(Email)',
  verify: "Verifying it's you",
  version: 'version',
  warning: 'Warning',
  web_kubectl: 'Web Kubectl',
  all: 'All',
  add_user: 'Add user',
  content: 'content',
  cpu: 'CPU',
  memory: 'Memory',
  backup_restore: 'Backup & Restore',
  products: 'Products',
  update_time: 'Update Time',
  secret: 'Secret',
  send_verify_code: 'Send Verification Code',
  p_i_first_name: 'Please enter first name',
  p_i_last_name: 'Please enter last name',
  verify_code: 'Verification Code',
  // value: "Value",
  operation_records: 'Operation Records',
  operation_type: 'Operation Type',
  action: 'Action',
  pn: 'PN',
  dataCenter: 'Datacenter',
  no_data: 'No data',
  delete_service: 'Delete Service',
  please_input: 'Please enter the {type} name',
  ingress: 'Ingress',
  batch_assign: 'Batch Assign',
  notification: 'Notification',
  whitelist: 'Whitelist',
  remove: 'Remove',
  batch_delete: 'Batch Delete',
  successfully: 'Successfully',
  error: 'Error',
  created: 'created',
  updated: 'updated',
  deleted: 'deleted',
  'please_input_ ': 'Please input ',

  // TableList
  // refresh: 'Refresh',
  // all: 'All',
  // please_input: 'Please enter {type} name',
  operator: 'Operator',

  // Modal
  ok: 'OK',
  // cancel: 'Cancel',
  operation: 'Operation',
  this_name_has_been_existed: 'This name has been already existed',
  // name_validate_error_msg: 'Only 0-9 a-z A-Z .- allowed',
  should_not_be_at_the_beginning_or_end: 'Special characters .- should not be at the beginning or end',

  // Login
  /*
  registered: 'Register',
  registered_title: 'Sign Up Now',
  registered_success: 'Registration was successful!',
  sign_in: 'Sign In',
  forgot_pwd: 'Forgot Password',
  retrieve_password: 'Retrieve your password',
  retrieve_password_sub: 'Enter your email address. A verification code will be sent later.',
  r_to_login: 'Return to login page',
  p_i_username_e: 'Please enter username(Email)',
  send_pwd_email: 'Send password reset Email',
  send_pwd_email_sub:
    'If you forget your password, you can use this tool to reset your password. After submission, you will receive an email verification code with a link to complete the process.',
  sign_in_sub: 'Sign in to Developer Network',
  // skip: 'Skip',
  go_to_change_pwd: 'Go To Change Password',
  system_notification: 'System Notification',
  password: 'Password',
  p_i_pwd: 'Please Input Your Password',
  // username_email: 'Username Email',
  p_i_username: 'Please Input Your Username',
  not_receive_email: 'Not Receive Email',
  // draft: 'Draft',
  // release: 'Release',
  // services_name: 'Services Name',
  beta_backends: 'Beta Backends',
  // Description: 'Description',
  // versionhistory: 'Version History',
  // please_select_config: 'Please Select Config',
  // please_select_service_name: 'Please Select Service Name',
  portservices: 'Port Services',
  // please_select_service: 'Please Select Service',
  Method: 'Method',
  Path: 'Path',
  // appgroup: 'App Group',
  // generate_token: 'Generate Token',
  true: 'True',
  // config_description: 'Config Description',
  // enable_auto_delete: 'Enable Auto Delete',
  // expose_service_address: 'Expose Service Address',
  write_able: 'Write Able',
  please_select_cluster: 'Please Select Cluster',
  please_select_namespace: 'Please Select Namespace',
  please_select_workspace: 'Please Select Workspace',
  api_versions: 'Api Versions',
  // service_infos: 'Service Infos',
  writable: 'Writable',
  // workload_name: 'Workload Name',
  // namespace_name: 'Namespace Name',
  // cluster_name: 'Cluster Name',
  // roll_back: 'Roll Back',
  enable_service_address: 'Enable Service Address',
  enable_autodelete: 'Enable Autodelete',
  workload_type: 'Workload Type',
  auth_token: 'Auth Token',
  // cluster: 'Cluster',
  datacenter: 'Data Center',
  // namespace: 'Namespace'
  services_address: 'Service Addresses',
  */

  pwd_rule_prompt_and_desc: 'Password rule prompt and description',
  return_to_log_in: 'Return to log in',
  enter_email_to_reset_pwd: 'Enter Email to Reset Password',
  reset_pwd: 'Reset Password',
  forget_pwd: 'Forget password',
  back_to_login: 'Already have an account? Log In',
  email_address: 'Email Address',
  or_third_party: 'OR',
  sign_up_text: 'Sign up for an account',
  u_n_or_p_w_d_error: 'The username or password is incorrect.',
  login_app_name: 'WISE-IoTSuite/MP',
  log_in_sub: 'Log in to {name}',
  registered: 'Register',
  registered_title: 'Sign Up Now',
  registered_success: 'Registration was successful!',
  sign_in: 'Sign In',
  forgot_pwd: 'Forgot Password',
  retrieve_password: 'Retrieve your password',
  retrieve_password_sub: 'Enter your email address. A verification code will be sent later.',
  r_to_login: 'Return to login page',
  p_i_username_e: 'Please enter username(Email)',
  send_pwd_email: 'Send password reset Email',
  send_pwd_email_sub:
    'If you forget your password, you can use this tool to reset your password. After submission, you will receive an email verification code with a link to complete the process.',
  sign_in_sub: 'Sign in to Developer Network',
  // skip: 'Skip',
  go_to_change_pwd: 'Go To Change Password',
  system_notification: 'System Notification',
  password: 'Password',
  p_i_pwd: 'Please Input Your Password',
  // username_email: 'Username Email',
  p_i_username: 'Please Input Your Username',
  not_receive_email: 'Not Receive Email',
  // draft: 'Draft',
  // release: 'Release',
  // services_name: 'Services Name',
  beta_backends: 'Beta Backends',
  // Description: 'Description',
  // versionhistory: 'Version History',
  // phone: 'Phone',

  portservices: 'Port Services',

  Method: 'Method',
  Path: 'Path',
  // appgroup: 'App Group',
  // generate_token: 'Generate Token',
  true: 'True',
  // config_description: 'Config Description',
  // enable_auto_delete: 'Enable Auto Delete',
  // expose_service_address: 'Expose Service Address',
  write_able: 'Writeable',

  api_versions: 'Api Versions',
  // service_infos: 'Service Infos',
  writable: 'Writable',
  // workload_name: 'Workload Name',
  // namespace_name: 'Namespace Name',
  // cluster_name: 'Cluster Name',
  // roll_back: 'Roll Back',
  enable_service_address: 'Enable Service Address',
  enable_autodelete: 'Enable Autodelete',
  workload_type: 'Workload Type',
  auth_token: 'Auth Token',
  // cluster: 'Cluster',
  datacenter: 'Data Center',
  // namespace: 'Namespace'
  services_address: 'Service Addresses',



  // Top Navbar

  // a
  // add_user: "Add user",

  // b
  billing_portal: 'Billing Portal',

  // c
  // cancel: "Cancel",
  // confirm: "Confirm",
  // contact_technical_support: "Contact Technical Support",

  // h
  hi: 'Hi, ',

  // l
  log_out: 'Log Out',
  log_in: 'Login',

  // m
  management_portal: 'Management Portal',

  // p
  public_private: 'Public/Private',
  // please_input: 'Please enter {type} name',

  // s
  // services: "Services",
  // support_message: "If you are experiencing issues and need technical support, please send an e-mail to",
  service_portal: 'Service Portal',

  // t
  themes: 'Themes',
  tickets: 'Tickets',
  ticket_portal: 'Ticket Portal',
  top_console: 'Console',

  // u
  units: 'Units',
  // user_center: "User Center",
  // subscription_name: "Subscription Name",

  // desc
  mp_desc:
    'Management Portal is the console of EnSaaS K8s Service, which provides users with an out-of-the-box microservice framework, an enterprise-class container management platform, multi-tiered tenant workspaces, and a consistent infrastructure interface that provides full lifecycle management for applications.',
  sso_desc:
    'User Center is a suite of secure, convenient, and open unified authentication services which WISE-PaaS provides users, including features such as user identity management, enterprise account management, client-side management, single sign-on support, and flexible application integration.',
  service_desc:
    'Service Portal is the console for all managed service instances such as multiple databases (PostgreSQL, MongoDB, InfluxDB, etc.), RabbitMQ message middleware and AIFS. Service Portal provides full lifecycle management capabilities such as database access and secret key creation, updates, and deletion of device access platforms with a convenient interface.',
  bill_desc:
    'Billing Portal is a fee center where users can view order status, transaction details, service prices, membership discounts and monthly bills etc. in real time.',
  ticket_desc:
    'Ticket Portal solves various tickets for platform users online. All subscription admins and users can create issue tickets through this system, and technical support engineers will handle them according to the type of problem and the details provided in the ticket.',
  container: 'Container',

  // =======================           Buy Portal           =======================
  // management: "Management",
  // console: "Console",
  // lang: "Languages",
  // catalog: "Catalog",
  // billing: "Billing",
  // tickets: "Tickets",
  // order: "Order",
  document: 'Document',
  blue: 'blue',
  sign_out: 'Log Out',
  available_day: 'Available Day',
  // user_center: "User Center",
  next: 'Next',
  // confirm: "Confirm",
  // cancel: 'Cancel',
  previous: 'Previous',
  // contact_technical_support: "Contact US",
  // support_message: "Technical Support, please email to",
  trouble_message: 'Troubleshooting, please email to',

  // =======================           EnSaaS Service Mesh Portal           =======================

  delete_batch_backend_info: 'Are you sure to delete these offline backend?',
  delete_all_offline_backend_info: 'Are you sure to delete all the offline backends of this service?',
  agent_update: 'Agent Update',
  agent_update_list: 'List all the information of Config Mgmt. Agents. There is only one agent in each cluster. Users could select the agent to update.',
  container_update: 'Container update',
  reg_release: 'Release',
  service_image_name: 'Service Image Name',
  sidecar_updatable: 'Sidecar Updatable',
  service_image: 'Container',
  images: 'Images',
  init_images: 'Init Images',
  update_sidecar: 'Update Sidecar',
  delete_all_backend_info: 'Are you sure to delete these backends?',
  beta: 'Beta',
  tag_name_exist: 'Tag name exist',
  unbindabled: 'Unbind',
  bindabled: 'Bind',
  config_edit: 'Config edit',
  import_config: 'Import config',
  config_management: 'Config Management',
  // config: "Config",
  configs: 'Configs',
  config_list:
    'Configuration can store the information of environment variables needed by each application, which can be divided into public configuration and private configuration, ',
  public_config_desc: 'Public configuration is the public configuration for all application groups.',
  private_config_desc:
    'Private configuration belongs to certain application group. All the services in the application group can access the private configuration in the application group.',
  // empty: "Empty",
  // version: "Version: ",

  // 左側選單
  groups: 'Groups',
  app_groups: 'App Groups',
  version_history: 'Version History',
  version_history_list:
    'Version History Management of configuration information supports rolling back to a version before the latest one; the maximum number of saved versions is the upper limit of version history of application group.',
  listening_management: 'Listening Management',
  listening_management_list:
    'Monitoring: Users can query the backend applications that use the SDK to listen for configuration changes; configuration monitoring queries with the dimensions of configuration and backend are supported.',
  group_management: 'App Group Management',
  registry: 'Registry',
  service_management: 'Service Management',
  backends: 'Backends',
  backends_list: 'Status display and editing of backend service instances (such as pods).',
  service_authentication: 'Service Authentication',
  port_service: 'Port Services',
  port_services_list:
    'Each service contains one or more service ports. Port Service Management displays the specific sub service information corresponding to each service port.',
  // service: "Service",
  traffic_management: 'Traffic Management',
  user_management: 'User Management',
  distributed_tracing: 'Distributed Tracing',
  // table-list 列表
  // edit: "Edit",
  // delete: "Delete",
  expose: 'Expose',
  import: 'Import',
  watch: 'Watch',
  view_service_registry_information: 'View Service Registry Information',
  view_group_information: 'View App Group',
  // whitelist: 'Whitelist',
  auth_filter: 'Auth Filter',
  resource_filter: 'Resource Filter',
  view_port_services: 'View Port Services',
  view_backends: 'View Backends',
  app_group: 'App Group',
  app_grou: 'App Group',
  app_group_list: 'A collection of applications that share some configuration or similar functions is called an application group.',
  view_history_information: 'View History',
  history_information: 'History Information',
  view_token: 'Update Service Config',
  token_information: 'Service Config Information',
  // loading: "Loading...",
  // Services
  service_name: 'Service Name',
  service_registry: 'Service Registry',
  // created_time: "Created Time",
  service_instance_id: 'Service Instance ID',
  subscription_id: 'Subscription ID',
  updated_time: 'Updated Time',
  time_stamp: 'Time',
  service_registry_information: 'Service Registry Information',
  total_pod: 'Total Pod',
  ready_pod: 'Ready Pod',
  pod_names: 'Pod Names',
  // create_time: "Create Time",
  // App Groups
  app_group_name: 'App Group Name',
  app_group_id: 'App Group ID',
  // description: "Description",
  salt: 'Salt',
  // quota: "Quota",
  // name: "Name",
  config_quantity: 'Config Quantity',
  backend_quantity: 'Backend Quantity',
  enable_tracing: 'Enable Tracing',
  config_name: 'Config Name',
  format: 'Format',
  // tag_name: 'Tag Name',
  // type: "Type",
  is_beta_release: 'Is Beta Release',
  release_status: 'Release Status',
  public_bindable: 'Public Bindable',
  beta_release: 'Beta Release',
  stop_beta: 'Stop Beta',
  //port services
  portServiceName: 'Port Service Name',
  internalAddress: 'Internal Address',
  externalAddress: 'External Address',
  svcAddress: 'Svc Address',
  // port: "Port",
  targetPort: 'Target Port',
  please_select_port_service: 'Please Select Port Service',
  // please_select_service: "Please Select Service",
  please_select_app_group: 'Please Select App Group',
  // rules: "Rules",
  skip_rules: 'Skip Rules',
  skip_rule: 'Skip Rule',
  format_is_not_valid: '{format} is not valid',
  // name_validate_error_msg: "Only a-z, 0-9 . and - allowed",
  // Resource Permission Management
  // resource_permissions_sub:
  //   "Create, assign, and manage user resource permissions and roles",
  // resource_permissions: "User Permissions",
  // highest_role: "Highest Role",
  // last_login: "Last Login",
  // last_name: "Last name",
  // status: "Status",
  group_status: 'Group Status',
  select_app_group: 'Select App Group',
  // user_info: "User Information",
  // user_info_sub: "Basic information and permissions of users",
  // username: "username",
  // first_name: "First name",
  // alternative_email: "Alternative Email",
  // contact_phone: "Contact Phone",
  // industry: "Industry",
  // country_region: "Country/Region",
  // company: "Company",
  // address: "Address",
  // city: "City",
  // user_base_info: "Basic information of users",
  office_phone: 'Office Phone',
  avatar: 'Avatar',
  postal_code: 'Postal Code',
  // resources_mgmt: "Resource management",
  // role: "Role",
  // select_role: "Select a role",
  // p_s_rc: "Please select a country or region",
  // workspace: "Workspace",
  data_center: 'Data Center',
  // invite: "Invite",
  // delete_role: "Are you sure you want to delete this role?",
  // resources_permission_exist: "Resource permission already exists",
  admin_resources_permission_exist: 'Admin permission already exists, do not permission add others',
  admin_role_permission_exist: 'Admin role already exists, do not permission add others',
  admin_permission_delete_other: 'If you add admin permission, others will be delete',
  admin_role_delete_other: 'If you add admin role, others will be delete',
  role_not_insert: 'Role is not insert',
  // delete_roles: "Are you sure you want to delete those roles?",
  // success_save: "Saved successfully",
  success_add: 'Add successfully',
  role_name: 'Role Name',
  // delete_user: "Are you sure you want to delete this user?",
  // not_login: "Not logged in yet",
  target_port: 'Target Port',
  svc_address: 'Svc Address',
  // internal_address: "Internal Address",
  // external_address: "External Address",
  delete_service_address: 'Are you sure to delete this service address from the list?',
  // save: "Save",
  description_config: 'Description',
  white_list: 'White List',
  add_rules: 'Add Rules',
  add_skip_rules: 'Add Skip Rules',
  add_skip_rules_all: 'Add Skip Rules All',
  add_env_var: 'Add Environment Variable',
  add_arg: 'Add Argumnet',
  group_basic_infomation: 'Group Basic Infomation',
  backend_name: 'Backend Name',
  listen_start_time: 'Listen Start Time',
  push_config_time: 'Push Config Time',
  is_successful: 'Is Successful',
  dimension_config: 'Config', //Query Dimension:
  dimension_ip: 'Backend',
  dimension: 'Dimension',
  please_select_dimension: 'Please Select Dimension',
  enable_white_list: 'Enable White List',
  add_white_list: 'Add White List',
  rate_limit: 'Rate Limit',
  circuit_breaker: 'Circuit Breaker',
  port_service_name: 'Port Service Name',
  method: 'Method',
  // path: "Path",
  period: 'Period',
  rate_limit_value: 'Rate Limit Value',
  enable_rate_limit: 'Enable Rate Limit',
  invite_user: 'Invite User',
  add_rate_limit: 'Add Rate Limit',
  port_services_name: 'Port Services Name',
  // protocol: 'Protocol',
  api_version: 'API Version',
  load_balancing: 'Load Balancing',
  max_connections: 'Max Connections',
  max_pending_requests: 'Max Pending Requests',
  max_requests: 'Max Requests',
  max_retries: 'Max Retries',
  resource_role_API: 'Resource Role API',
  group_basic_information: 'Group Basic Information',
  history_version_quantity: 'History Version Quantity',
  config_size_kb: 'Config Size(KB)',
  // id: "Config ID",
  rateLimitValue: 'Rate Limit Value',
  please_select_port_service_name: 'Please Select Port Service Name',
  flowcontrol: 'Flow Control',
  offline_time: 'Offline Time',
  auto_delete_time: 'Auto Delete Time',
  delete_sidecar: 'Delete Sidecar',
  sidecar: 'Sidecar',
  canary: 'Canary',
  main_weight: 'MainWeight',
  mainWeight: 'MainWeight',
  canary_weight: 'CanaryWeight',
  canaryWeight: 'CanaryWeight',
  container_name: 'ContainerName',
  containerName: 'ContainerName',
  image: 'Image',
  replace_env: 'ReplaceEnv',
  replaceEnv: 'ReplaceEnv',
  replace_args: 'ReplaceArgs',
  replaceArgs: 'ReplaceArgs',
  env: 'Env',
  arg: 'Arg',
  enable_resource_role: 'Enable Resource Role',
  enable_authentication: 'Enable Authentication',
  enable_canary: 'Enable Canary',
  has_sidecar: 'Has Sidecar',
  config_id: 'Config ID',
  please_select_backend_name: 'Please Select Backend Name',
  view_service: 'View Service',
  enable_service_auth: 'Enable Service Auth',
  sso_auth_filter: 'SSO Auth Filter',
  ensass_role_filter: 'Ensass Role Filter',
  // disabled: "Disabled",
  is_disabled: 'Enabled',
  access_token: 'Access Token',
  config_names: 'Config Names',
  token: 'Token',
  all_user: 'All Users',
  admin: 'Admin',
  app_group_owner: 'AppGroupOwner',
  numbers_only: 'Numbers only',
  // service_infos: "Service Infos",
  // generate_token: "Generate Token",
  // services_name: "Services Name",
  // Description: "Description",
  // expose_service_address: "Expose Service Address",
  // enable_auto_delete: "Enable Auto Delete",
  // appgroup: "App Group",
  appgrou: 'App Group',
  // config_description: "Config Description",
  // draft: "Draft",
  // release: "Release",
  // please_select_config: "Please Select Config",
  // please_select_service_name: "Please Select Service Name",
  // roll_back: "Roll Back",
  // versionhistory: "Version History",
  // workload_name: "Workload Name",
  // namespace_name: "Namespace Name",
  // cluster_name: "Cluster Name",
  portservice: 'Port Service',
  // please_select_service: "Please Select Service",
  backend: 'Backend',
  // username_email: "Username Email",
  // skip: "Skip",
  // namespace: "Namespace",
  // cluster: "Cluster",

  restart_backends: 'Restart Backends',
  edit_sidecar: 'Edit Sidecar',
  restart_backends_tip: 'Restart all backends of service name',
  // cpu: "Cpu",
  // memory: "Memory",
  ephemeral_storage: 'Ephemeral Storage',
  requests: 'Requests',
  limits: 'Limits',
  config_editing: 'Editing',
  current_config: 'Current Config',
  backends_information: 'Backends Information',
  is_initialized: 'Is Initialized',
  is_canary: 'Is Canary',
  enbal_tracing: 'Enbal Tracing',
  ip: 'Ip',
  service_location: 'Service Location',
  global: 'Global',
  requests_or_limits_one_field_is_required: 'Requests Or Limits One Field Is Required',
  sidecar_injected: 'Sidecar Injected',
  del_config: 'config',
  public_config_delete_info: 'Becarefully: It will delete the public config and all of the config release, beta release, draft, release history and so on',
  config_type: 'Config Type',
  tag_description: 'Tag Description',
  requests_limits: 'Requesets must be less than or equal to Limits',
  export_config_tip: 'Are you sure export the config ?',
  file_is_invalidate: 'The format of config file is invalid.',
  license_invalid_after: 'License Invalid After ',
  n_days: ' Days',
  license_invalid_immediately: 'License Invalid Soon',
  workloads_list: 'Service registration function to inject workload into sidecar.',
  please_select_config_type: 'Please Select Config Type',
  user_permission: 'User Permission',
  is_inject: 'Sidecar Injected',
  workload: 'Workload',
  workloads: 'Workloads',
  role_mgmt: 'Role management',
  global_auditor: 'Global Auditor',
  token_path_info1: 'Note: Please add the below info into your deployment of the service, just under metadata.annotations:',
  token_path_info2: 'ensaas.k8s.io/accesstoken:<token value>',
  service_address_desc: 'This is the public service addresses, which is displayed when the injection sidecar selects the expose service address option',
  sidecar_is_inject: 'Sidecar has inject',
  roll_back_to: 'Roll back to {item} ?',
  active_backends: 'Active Backends',

  // =======================           Tunnel Server           =======================

  // Client Management
  clients: 'Clients',
  clients_desc:
    'Clients can be located in a cluster, container, virtual machine, or physical machine used to communicate with the tunnel service side. Before establishing a tunnel, you need to have at least one client.',
  client: 'Client',
  detail: 'Details',
  // delete_msg: 'Are you sure to delete this {item}?',
  please_input_tunnel: 'Please input {type} name',
  client_ip: 'Client IP',
  deploy_file: 'Deploy File',
  deploy_guide: 'Deploy Guide',
  client_hint: `### **Tips**
  When you finish adding a client, only the client information is created, you will also need to deploy the client entity. Please click on the operation button -> Details on the right side of the client to view the client details, and deploy the client based on the instructions there`,
  deploy_doc: `### **Deploy with Deployment**
1. Click the expand button to the left of the deployment file to view the deployment file.
2. Click the download button on the right to download the deployment file. The downloaded file name defaults to: \\<Client Name\\>.yml
3. Go to the directory for the deployment file downloaded in step 2 and run the following command to complete the client deployment. Note to replace those to your deployment file and namespace name

  \`$ kubectl apply -f <Deploy File Name>.yml -n <Namespace Name>\`
  `,
  import_doc1: 'Depending on your environment, download the script to get token. Currently ',
  import_doc2: ` is supported.`,
  import_doc3: `2. The files downloaded by Windows are saved as \\<filename\\>.bat, while the files downloaded by linux are saved as \\<filename\\>.sh
  3. Run the script downloaded in Step 2 to get the token and server.`,
  import_doc4:
    "4. Copy the content between '----' marks into the input box below, which contains token and host information, and the page will automatically recognize the token and server, and fill them in the input box corresponding to the mapping information.",
  // import_doc4: '4. Copy the contents of the token (without "token:") and paste it into the token input box in the cluster mapper.',

  // Tunnels
  tunnels: 'Tunnels',
  tunnels_desc:
    'Tunnels can be used for intranet penetration. The external network can access services built on the intranet anywhere anytime through the domain name provided by tunnels.',
  a_type_must_be_selected: `A {type} must be selected`,
  mapping_type: 'Mapping Type',
  mapping_info: 'Mapping Info',
  port_err: 'Only numbers (0-65535) accepted',
  ip_err: 'Please enter valid IP',
  hostname_err: 'Only 0-9 a-z A-Z - allowed',
  hostname_err_internal: 'Only 0-9 a-z A-Z . and - allowed',
  tunnel: 'Tunnel',
  type_card: '{type}: ',
  cluster_info: 'Cluster Info',
  cluster_token: 'Cluster Token',
  access_address: 'Access Address',
  external_server_card: '{access_address}: ',
  internal_server: 'Internal Server',
  internal_server_card: '{internal_server}: {internal_addr}',
  cluster_host: 'Cluster Host',
  // web_kubectl:'Web Kubectl',
  copy: 'Copy',
  download_tunnel: 'Download',
  certificate: 'Certificate',
  key_tunnel: 'Key',
  root_certification: 'Root Certification',
  diagnosis: 'Diagnosis',
  diagnosis_info: `**{name}**

  Diagnosis Domain: {domain}
  Forward server IP: {forward_server_ip}
  Tunnel: {dns_ip}
  LAN server: {internal_server_address}
  Local Intranet IP: {internal_server_ip}
  Agent IP: {agent_ip}
  {status}`,
  view_help: 'View Help',
  get_token: 'Get Token',
  code1000:
    'The domain name has activated the intranet penetration function and is consistent with the forwarding server IP pointing. The connection to the forwarding server was successful',
  code1001: 'The external domain name of the intranet map is misresolved, and the domain name does not activate the intranet transmission function',
  code1002: 'The client of the intranet map is offline',
  code1003: 'The creation of a connection between the server and the agent of the intranet map failed',
  code1004: 'The LAN server connection failed',
  // ingress: 'Ingress',
  // batch_assign: 'Batch Assign',

  // Security Settings
  security_settings: 'Security Settings',
  // whitelist: 'Whitelist',
  type_whitelists: '{type} Whitelists',
  // remove: 'Remove',
  move_up: 'Move Up',
  move_down: 'Move Down',
  ip_address: 'IP Address',

  // =======================           Bill Portal           =======================

  //type: 'Type',
  //company: 'Company',
  //status: 'Status',
  //service: 'Service',
  // subscription_name: "Subscription Name",
  orderId: 'Order ID',
  subscriptionId: 'Subscription ID',
  transactionId: 'Transaction ID',
  createdAt: 'Created At',
  activedAt: 'Actived At',
  orderSource: 'Order Source',
  serviceName: 'Service Name',
  serviceCategory: 'Service Category',
  plan: 'Plan',
  partNumber: 'PN',
  isPaidAccount: 'Is Paid Account',
  time: 'Time',
  // pn: 'PN',
  identity: 'Your identity is',
  here_is: 'Here is your total memberPrice',
  totalProratedPrice: 'Total Prorated Price',
  orderStatus: 'Status',
  activated_at: 'Activated At',
  ended_at: 'Ended At',
  actions: 'Actions',
  view_details: 'View Details',
  all_reset: 'Reset All',
  totalListingPrice: 'Total Listing Price',
  totalMemberPrice: 'Total Member Price',
  total_Prorated_Price: 'Total Prorated Price',
  totalListingProratedPrice: 'Total Listing Prorated Price',
  totalDiscountPrice: 'Total Discount Price',
  currency_unit: 'Currency Unit',
  deduction: 'Deduction Type',
  notice_tip: 'After choosing to close, it will assume that you have read the announcement and will not be displayed again next time, please be aware!',
  crmId: 'CRMID',
  subscriptionName: 'Subscription Name',
  // dataCenter: 'Datacenter',
  wiseType: 'Wise Type',
  prepaidServiceCharges: 'Prepaid Service Charges',
  prepaidMemberDiscounts: 'Prepaid Member Discounts',
  postpaidUsageCharges: 'Postpaid Usage Charges',
  postpaidMemberDiscounts: 'Postpaid Member Discounts',
  totalCharges: 'Total Charges',
  total: 'Total',
  totalPostpaidMemberDiscounts: 'Total Postpaid Member Discounts',
  totalPostpaidUsageCharges: 'Total Postpaid Usage Charges',
  totalPrepaidMemberDiscounts: 'Total Prepaid Member Discounts',
  totalPrepaidServiceCharges: 'Total Prepaid Service Charges',
  bill_tip:
    'The total cost for the current month will be generated at the beginning of the next month. You can view and export the bill after 10:00 am on the fourth day of the next month.',
  Bill: 'Bill',
  Order: 'Order',
  bill_cycle: 'Bill Cycle',
  time_period: 'Time',
  discount_rate: 'Discount Rate',
  export_content: 'Exported Content:',
  current_list: 'Current List',
  current_unit: 'Current Currency Unit:',
  export_bill: 'Export Billing Overview (CSV)',
  export_order: 'Export Order Overview (CSV)',
  crmIdName: 'CRMID Name',
  exchangeRateDiscount: 'Exchange Rate',
  serviceCharges: 'Charges',
  memberDiscounts: 'Discounts',
  charges: 'PAYG Charges',
  payg_details: 'PAYG Details',
  // =======================           Catalog Portal           =======================
  //blue: 'Blue',
  //not_receive_email: 'Didn\'t receive the registration Email?',
  //sign_in_sub: 'Sign in with EnSaaS SSO account',
  //username: 'Username (Email)',

  // action: 'Action',
  // add: "Add",
  add_catalog: 'Add catalog',
  add_project: 'Add project',
  // add_user: "Add user",
  admin_theme_name: 'Admin Account Management',
  admin_theme_subname:
    'Account management system administrator USES this function module to manage accounts, such as create, update, read, delete admin account, etc',
  admin_account: 'Admin Account',
  apps_info: 'Apps Info',
  apps_info_content: 'Users can see all the apps under the added apps address, and view and deploy them.',
  app_version: 'App version',

  // b
  back_to_list: 'Back To List',
  basic_info: 'Basic Info',

  // c
  catalog_info: 'Catalog info',
  catalog_number: 'Catalog Numbers',
  create_project: 'Create Project',
  create_admin: 'Create admin',
  charts: 'Charts',
  chart_version: 'Chart version',
  create_retry: 'SSO account creation failed, please try again!',
  create_success: 'SSO account was created successfully, click confirm to enter EnSaaS Portal or login mailbox.',
  confirm_login: "You haven't logged in yet, are you sure you want to log in now?",
  condition_acount_type:
    'Application for the enterprise account management mechanism is available immediately. Member types of VIP and above can apply for enterprise accounts.',
  condition_personal_info: 'Completely fill in the company and personal information, and ensure that they are true and effective',

  // d
  deploy_App: 'Deploy App',
  deploy_App_suc: 'Deploy app success!',
  developer: 'Developer: ',

  // e
  edit_catalog: 'Edit catalog',
  edit_project: 'Edit project',
  empty_description: 'No Data',
  external_host: 'External Host',
  edit_by_form: 'Edit By Form',
  edit_by_yaml: 'Edit By YAML',
  // events: "Events",
  events_content: 'The user can see the relevant operation record.',
  eam_mechanism: 'Enterprise Account Management Mechanism',
  eam_mechanism_launch: 'Enterprise Account Management Mechanism',
  eam_des:
    'Enterprise account management agreement supports the resale of cloud services, which can help our domain focus system integrators and resellers to easily manage their customers. With this mechanism, an IoT ecosystem can be successfully created.',
  'eam agreement': 'Enterprise account management agreement',
  eam_conditions: 'Enterprise account application conditions',
  eam_account_pwd:
    'After your enterprise account is successfully created, you should keep your account information safe and use them properly. You should be responsible for the losses and consequences caused by the disclosure of your account information, or any exposure to attacks or frauds; the cloud platform is not responsible for the aforemetnioned losses.',
  eam_administrator: ` You should create a sub-subscription administrator account with the real name of the person who manages the sub-subscription account's network and various applications and services on the cloud platform. If the sub-subscription administrator has been changed, you should update the related information online by yourself. The cloud platform will not be responsible for any consequences arising from the untrue, inaccurate and incomplete personnel information that you provide, as well as the actions or omissions of the above personnel, or your failure to update personnel changes online in a timely manner.`,
  eam_deploy:
    'Individuals are responsible for the applications deployed on the exclusive space of the cloud platform. In addition, self-upgrading applications may cause adverse effects such as crashes. Individuals should bear their own risks and be responsible for operating carefully.',
  eam_follow_agreement:
    'You understand and agree that you and your end users need to abide by this agreement "WISE-PaaS Industrial Internet of Things Cloud Platform Service Agreement", and and also the necessary settings and generally accepted principles of use. You and your end users should use the support platform when require assistance. The cloud platform is not responsible for any damages caused by conforming to the features and functions of the services (for example, attempting to perform unsupported tasks), or not complying with the guidelines published by the cloud platform, and you shall bear all existing and derivative obligations and responsibilities.',
  eam_platform_doc:
    'The functions of the related services provided by the cloud platform are subject to the user guide published on the {website}. You can also refer to the cloud platform technical white paper "WISE-PaaS Industrial Internet of Things Cloud Platform Architecture and Services". The cloud platform has the right to update the functions and related documents of the service in a timely manner. Please log in to the {website} to check the latest version of the related documents.',
  eam_answered: 'The application will be answered and delivered within 3 working days.',
  ea_apply: 'Enterprise Account Application',
  ea_VIP: 'Only member types of VIP and above can apply for enterprise accounts',

  // f
  feature_setting: 'Feature Setting',
  free_trial_product: 'Free Trial of Cloud Products',
  free_trial_desc: 'Experience super fast, multi-scenario, easy to operate and maintain IoT cloud products for free.',

  // g
  group_theme_name: 'Group',
  group_theme_subname:
    'Group is a logical unit that organizes your projects, manages access to resources, and shares resources within your team as an independent workspace for your team.',
  group_list: 'GroupList',
  group_owner: 'Group Owner',
  go_now: 'GO NOW',

  // h
  histories: 'Histories',

  // i
  IApp_title: 'I.App',
  IApp_s_p: 'I.App Starter Package',
  IApp_subtitle: 'Users can see applications of different service category with permissions and quickly deploy them.',
  internal_host: 'Internal Host',
  invite_member: 'Invite member',
  info: 'Info',

  // j

  // k
  key_management: 'Key Management',

  // l
  // last: "Last: ",
  last_login_time: 'Last Login Time',
  last_update_time: 'Last Update Time',
  limit: 'Limit',
  load: 'Loading',
  load_fail: 'Load failed',
  loading_app: 'Loading app list...',
  loading_catalog: 'Loading catalog list...',
  loading_group: 'Loading group list...',
  loading_plugin: 'Loading plugin list...',
  loading_project: 'Loading project list...',
  loading_records: 'Loading subscription records...',
  logging: 'Logging',
  login_success: 'Login success',
  login: 'Login',
  learn_more: 'Learn More',

  // m
  managed: 'Managed',
  marketplace: 'Marketplace',
  marketplace_setting: 'Marketplace Setting',
  marketplace_setting_content: 'Admin account can set up marketplace catalog, and users of the entire system can deploy it.',
  member_theme_name: 'Member Management',
  member_theme_subname: 'List the group owner of the group.',
  more: 'more',
  my: 'My',
  my_content: 'Users can see the Catalog to which they have subscribed.',
  my_subscription: 'My Subscription',
  my_subscriptions: 'My Subscriptions',
  m_s_r: 'Monthly Subscription / Redeem',

  // n
  // notification: 'Notifications',
  no_show: "Don't show again next time.",
  new_product: 'New Product Release',
  // no_data: "no data",
  notification_theme_name: 'Notification',
  notification_theme_subname: 'Notification allows you to view the latest all notifications.',
  no_email: 'Sorry, the login entrance of this mailbox was not found, please log in the mailbox and check the password by yourself.',

  // o
  // overview: "Overview",
  official_website: 'official website of the cloud platform',

  // p
  project: 'Project',
  projects: 'Projects',
  project_theme_subname: 'Each tenant can create multiple projects and assign them to different members to manage.',
  pipeline: 'Pipeline',
  pipeline_number: 'Pipeline Numbers',
  private: 'Private',
  private_groups: 'Private Groups',
  // products: 'Products',
  project_number: 'Project Numbers',
  // property: 'Property',
  public_catalog: 'Public catalog',
  public_catalog_them_name: 'Public Catalogs',
  public_catalog_them_subname: 'Users can see applications with permissions and quickly deploy them.',
  purple: 'Purple',
  pricing_details: 'Pricing Details',
  product_release: 'Product release',
  project_owner: 'Project Owner',
  public_setting: 'Public Setting',
  purchase_options: 'Pricing Details',
  position_tips: 'Based on your current location, it is recommended that you view content that applies to your location.',
  public_setting_content: 'Admin account can set up public catalog, and users of the entire system can deploy it.',

  // q
  quick_start: 'Quick Start',
  quick_use: '6 Steps to Get Started with WISE-PaaS/IoTSuite.',
  // r
  // remember_me: "Remember me",
  records: 'Records',
  // refresh: "Refresh",
  resume: 'Resume',
  rollback: 'Rollback',
  release_note: 'Release Note',
  resale_services: 'Resale cloud services with WISE-PaaS/EnSaaS Enterprise Account.',

  // s
  // search: "search",
  select_date: 'Select Date',
  service_provider: 'Service Provider',
  // 修改
  logOut: 'Log Out',
  started: 'Started',
  subscribed: 'Subscribed',
  redeem: 'Redeem',
  subscription_records: 'Subscription Records',
  subscription_records_content: 'User can see the records history of subcription.',
  subTitle: 'subTitle',
  sure_to_delete: 'Sure to delete?',
  system_setting: 'System Setting',
  service_category: 'Service Category',
  s_a_s_c: 'Service Architecture & Successful Cases',
  service_details: 'Service Details',
  CST: 'WISE-PaaS Cloud Service Trial Sign Up',
  selectService: 'Please select service you are trialing',
  saleskit_desc: 'One-Stop Industrial IoT Application Development Kit and Cloud-Native Platform.',

  // t
  tenant: 'Tenant: ',
  theme: 'Theme',
  thirdparty_setting: 'ThirdParty Setting',
  title: 'Title',
  tip: 'Tips',

  // u
  unstarted: 'Unstarted',
  up: 'up',
  userCenter: 'User Center',
  update_app: 'Update App',
  update_app_suc: 'Update App success!',
  URL_Address: 'URL Address',
  // user: "user",
  user_name: 'User Name',

  // v
  // view: "View",
  version_info: 'Version Info',
  view_email: 'View Email',

  // w

  // x

  // y
  you_go_to_now: 'You will now go to: ',
  // z

  //试用申请页面
  Developer: 'Developer',
  'IT operation and maintenance': 'IT operation and maintenance',
  Student: 'Student',
  'Business decision-maker': 'Business decision-maker',
  'Technology decision-maker': 'Technology decision-maker',
  Architect: 'Architect',
  Other: 'Other',
  'Subscription Id': 'Subscription ID',
  CRMID: 'CRMID',
  'User Info': 'User Info',
  Company: 'Company',
  Email: 'Email',
  'Contact Phone': 'Contact Phone',
  Profession: 'Profession',
  'Trial Service': 'Trial Service',
  'Service Category': 'Service Category',
  'Service Name': 'Service Name',
  'Service Plan': 'Service Plan',
  'Apply Questionnaire': 'Apply Questionnaire',
  format_err: 'The format is incorrect.',
  i_agree: 'I have read and agree',
  agreement: 'WISE-PaaS Cloud Service Trial agreement',
  'First Name': 'First Name',
  'Last Name': 'Last Name',
  'Member Type': 'Member Type',
  // desc
  // mp_desc:
  //     "Management Portal is the console of EnSaaS K8s Service, which provides users with an out-of-the-box microservice framework, an enterprise-class container management platform, multi-tiered tenant workspaces, and a consistent infrastructure interface that provides full lifecycle management for applications.",
  // sso_desc:
  //     "User Center is a suite of secure, convenient, and open unified authentication services which WISE-PaaS provides users, including features such as user identity management, enterprise account management, client-side management, single sign-on support, and flexible application integration.",
  // service_desc:
  //     "Service Portal is the console for all managed service instances such as multiple databases (PostgreSQL, MongoDB, InfluxDB, etc.), RabbitMQ message middleware and AIFS. Service Portal provides full lifecycle management capabilities such as database access and secret key creation, updates, and deletion of device access platforms with a convenient interface.",
  // bill_desc:
  //     "Billing Portal is a fee center where users can view order status, transaction details, service prices, membership discounts and monthly bills etc. in real time.",
  // ticket_desc:
  //     "Ticket Portal solves various tickets for platform users online. All subscription admins and users can create issue tickets through this system, and technical support engineers will handle them according to the type of problem and the details provided in the ticket.",

  // =======================          Minisite Portal          =======================

  // Keywords for model
  announcement: 'Announcement',
  product_guides: 'User Guide',
  product_brief: 'Product Briefing',
  report_bug: 'Contact Us',
  faq: 'FAQ',
  technology_blog: 'Technical White Paper',
  troubleshoot: 'TroubleShooting',
  no_language_version: 'There is no {value} version for the data',
  admin_console: 'Admin Console',
  product_title: 'EnSaaS Minisite',
  technical_documentation: 'Technical Documentation',
  market_resources: 'Marketing Resources',
  summit: 'IoT Summit',
  resource_center: 'Resource Center',
  resource_center_desc: 'At the Advantech Resource Center, you will have access to industrial IoT news and the latest technical information.',
  app_name_minisite: 'App name',
  please_select_role: 'Please select role',
  select_product: 'Please select',
  please_select_service_name: 'Please select service name',
  please_select_appname: 'Please select appname',
  confirm_to_delete_role: 'Are you sure to delete this role?',
  add_role_warn: 'This permission already exists, do not add it repeatedly!',
  add_admin_role_warn: 'The highest permission has been added without additional permissions!',

  // MD
  view_detail: 'View Details',
  view_more: 'View More',
  more_upper: 'More ',
  immediately_view: 'Immediately View',
  free_trial: 'Get Free Trial Now',
  // total_items: "Total {value} items",
  input_require_desc: 'Please input the requirement overview',
  upload: 'Upload images',
  upload_label: 'Click or drag file to this area to upload',
  upload_remark: 'Support for a single or bulk upload (Maximum of three files)',
  business_support: 'Business support',
  technical_support: 'Development of technical support and training and certification',
  cloud_service: 'Cloud service failure sfix, subscription, and permission-related issues',
  email: 'Email',
  submit_success: 'Success',
  submit_error: 'Error',
  success_desc: 'Message sent successfully!',
  error_desc: 'Message sent failed!',
  muti_error: 'Only three files can be uploaded at most!',
  app_detail: 'App Detail',
  product_publish: 'published',
  please_input_search: 'Please input search keywords',

  // Contact us
  bug_desc: 'Detailed Description',
  require_desc: 'Requirement Overview',
  input_email: 'Please input email',
  textArea: 'Please input detailed description',
  submit_problem: 'Submit question form',
  service_need: 'The services you may need',
  download: 'Technical Information Download',
  know: ' I know',
  forward_login: 's later, it will jump to the login page',

  // Guides
  year: 'years ago',
  month: 'months ago',
  day: 'days ago',
  hour: 'hours ago',
  minute: 'minutes ago',
  second: 'seconds ago',

  // =======================           mp Portal           =======================

  // 'management': 'Management',
  // 'console': 'Console',
  // 'lang': 'Languages',
  // 'catalog': 'Catalog',
  '.and-should_not_be_at_the_beginning_or_end': '. and - should not be at the beginning or end',
  // a
  active: 'Active',
  active_line: 'Active',
  active_time: 'Active Time',
  // add: 'Add',
  // address: 'Address',
  after_restart: 'After Restart',
  // 'all': 'All',
  // alternative_email: 'Alternative Email',
  and_bath_assign: ' and batch Assign',
  application: 'application',
  application_management: 'Application Manegement',
  applications: 'Applications',
  applications_desc:
    'Provide an application-level perspective, view deployment status and changes at the application level, and at the same time upgrade, redeploy, start, stop, and manage applications.',
  are_you_sure_to_map_the_key_to_quota: 'Are you sure to map the {key}(s) to quota ',
  'are_you_sure_to_unassign the quota_quotaName_in_namesapce_namespaceName': 'Are you sure to unassign the quota {quotaName} in namesapce {namespaceName} ?',
  are_yuo_sure_to_delete_follow_users_permission: 'Are you sure to delete the following  users  permission?',
  assign_quota: 'Assign Quota',
  assign_quota_msg: 'The quota of {key} {keyName} has been assigned to {quotaInit}. Are you sure to change it to {quotaNew} ?',
  auto_scale: 'AutoScale',
  auto_scale_desc:
    "Whether to enable workspace's auto-scaling feature. Setting it to false means a fixed workspacequota is bound to this workspace, or true, which means auto-scaling is enabled for this workspace, which is no longer bounded to a fixed workspacequota but changes dynamically between minQuota and maxQuota.",
  available_quotas: 'Available Quotas',

  // b
  back_to_mp: 'Back to',
  // batch_assign: 'Batch Assign',
  basic_information: 'Basic Information',
  batch_add: 'Batch Add',
  // batch_delete: 'Batch Delete',
  before_restart: 'Before Restart',
  broker_host: 'Broker Host',
  // billing: 'Billing',

  // c
  // cancel: 'Cancel',
  clear: 'Clear',
  click_to_sort_by_ascending: 'Click to sort by ascending',
  click_to_sort_by_descending: 'Click to sort by descending',
  click_to_cancel_sorting: 'Click to cancel sorting',
  cluster_lower: 'cluster',
  // cluster: 'Cluster',
  clusters: 'Clusters',
  clusters_desc: 'Clusters are a collection of compute, storage, and network resources that Kubernetes uses to run a variety of container-based applications.',
  cluster_information: 'Cluster Information',
  cluster_initialization: 'Initialize Cluster',
  cluster_status: 'Cluster Status',
  cluster_agent: 'Cluster/Clusteragent',
  close: 'Close',
  close_switch: 'close',
  // city: 'City',
  // company: 'Company',
  compute_resource_quota: 'Compute Resource Quota',
  // 'config': 'Config',
  config_host: 'Config Host',
  config_map: 'ConfigMap',
  // confirm: 'Confirm',
  // contact_phone: 'Contact Phone',
  // 'contact_technical_support': 'Contact Technical Support',
  count: 'Count',
  // country_region: 'Country/Region',
  // cpu: 'CPU',
  // 'create': 'Create',
  cpu_nodes: 'CPU Nodes',
  create_cluster_lower: 'Create cluster',
  create_workspace_lower: 'Create workspace',
  create_namespace_lower: 'Create namespace',
  create_workspacequota_lower: 'Create workspaceQuota',
  create_namespacequota_lower: 'Create namespaceQuota',
  // 'create_time': 'Create Time',
  created_at: 'Created At',
  current_application: 'Current Application',
  current_cluster: 'Current Cluster',
  current_namespace: 'Current Namespace',
  current_quota: 'Current Quota',
  current_workspace: 'Current Workspace',

  // d
  // data_center: 'Data Center',
  datacenter_code: 'Datacenter Code',
  dedicate_cluster: 'Dedicate Cluster',
  'defer_scale-in_for': 'Defer Scale-in For',
  'defer_scale-in_for_desc': 'The amount of time that the workspace must wait before it scales in. Unit: minutes. The default value is 10 minutes.',
  // 'delete': 'Delete',
  // delete_role: 'Are you sure you want to delete this role?',
  // delete_roles: 'Are you sure you want to delete those roles?',
  // delete_user: 'Are you sure you want to delete {name}?',
  // deleted: 'Deleted',
  deleting: 'Deleting',
  deployed: 'Deployed',
  delete_desc: 'Are you sure to delete it?',
  delete_quota_desc: 'The quota is now in use and cannot be removed',
  delete_results_are_follows: 'Delete results are as follows:',
  details: 'Details',
  // disabled: 'Disabled',
  donot_unassign_auota: 'The {key} can not be unassigned!',
  download_config_error: 'Download config error!',

  // e
  // 'edit': 'Edit',
  edit_cluster_lower: 'Edit cluster',
  edit_workspace_lower: 'Edit workspace',
  edit_namespace_lower: 'Edit namespace',
  edit_desc: 'Are you sure to edit yaml?',
  edit_yaml: 'Edit Yaml',
  // 'empty': 'Empty',
  // error: 'Error',
  external_domain: 'External Domain',
  // events: 'Events',

  // f
  failed: 'Failed',
  // first_name: 'First name',
  // forgot_pwd: "Forgot password",

  // g
  general_workspaces: 'General Workspaces',
  gpu_nodes: 'GPU Nodes',
  guide_step1: 'Added new feature "Toolbox". Try it!',

  // h
  // hi: 'Hi',
  // highest_role: 'Highest Role',

  // i
  // industry: 'Industry',
  infrastructure: 'Infrastructure',
  // ingress: 'Ingress',
  // invite: 'Invite',
  ingress_desc: 'Ingress exposes HTTP and HTTPS routes from outside the cluster to services within the cluster.',
  ingress_overview: 'Ingress Overview',
  initialization: 'Initialize',
  install_package: 'Install Package',
  internal_domain: 'Internal Domain',
  invite_user_to_cluster_or_workspace: 'User already exist, would you like to invite this user to your cluster or workspace?',

  // j

  // k

  // l
  last: 'Last',
  // last_login: 'Last Login',
  // license_invalid: "License invalid, service was stopped",
  // license_invalid_days_14: 'License invalid, service is still available for 14 days',
  // license_invalid_days_front: 'License invalid, service is still available for ',
  // license_invalid_days_last: ' days',
  // license_invalid_immediately: 'License invalid, service will be unavailable soon',
  // last_name: 'Last name',
  // loading: 'Loading',
  log: 'Log',
  // log_out: 'Log Out',

  // m
  max_quota: 'MaxQuota',
  max_quota_desc:
    'The maximum workspacequota that automatically scales. You can only select one of the 16 built-in Quotas, and it must be larger than minQuota.',
  // memory: 'Memory',
  min_quota: 'MinQuota',
  min_quota_desc:
    'The minimal workspacequota that automatically scales. You can only select one of the 16 built-in quotas. and it must be smaller than maxQuota.',
  minutes: 'minutes',
  monitor: 'Monitor',
  mp_reactour_step1: 'Pod restart events is added to the events menu!',
  mp_reactour_step2: 'Service Usage functionality is added to the Monitor page!',
  mp_reactour_step3: 'Service Portal has been moved here!',

  // n
  // 'name': 'Name',
  name_input: ' name',
  namespace_lower: 'namespace',
  // 'namespace': 'Namespace',
  namespace_unbind: 'Namespace(Unbind)',
  namespace_bind: 'Namespace(Bind)',
  namespaces: 'Namespaces',
  namespaces_desc:
    'A namespace is an abstract collection of resources and objects that provide isolation and is often used to divide objects within a system into different project or user groups.',
  namespace_information: 'Namespace Information',
  namespacequota_lower: 'namespacequota',
  namespacequota: 'NamespaceQuota',
  namespaceQuota: 'NamespaceQuota',
  namespacequotas: 'Namespace Quotas',
  'namespace quotas': 'NamespaceQuotas',
  namespace_quotas: 'NamespaceQuotas',
  'namespace-quotas': 'NamespaceQuotas',
  namespace_quotas_desc: 'NamespaceQuotas are a mechanism used to limit the amount of user resources used. Amount of resources used to name workspaces.',
  namespace_scale_desc: 'Resources quota is used to restrict the user resources consumption of a mechanism, applied to namespace',
  namespace_status: 'Namespace Status',
  namespace_usage_t5: 'Namespace Usage (Top 5)',
  no_any_been_assigned: 'No any been Assigned',
  // 'no_data': 'No Data',
  node: 'Node',
  nodes: 'Nodes ',
  nodes_desc: 'The node is the working host in the cluster on which the pod actually runs. It can be a physical machine or a virtual one.',
  node_usage_t6: 'Node Usage (Top 6)',
  // not_login: 'Not logged in yet',
  // not_receive_email: "Didn't receive the registration Email?",
  notice_front: `KubeEnSaaS has been updated to version 4.0.20. In order to further enrich the usage scenarios of users, we added the operation and management of GPU resources in this version. For more new features, please refer to`,
  notice_back: '.',
  no_cluster: 'No Cluster',
  no_workspace: 'No Workspace',
  no_plan: 'No Plan',
  now_replicas: 'Now replicas',
  new_replicas: 'New replicas',

  // o
  object_count_quota: 'Object Count Quota',
  // 'ok': 'OK',
  offline: 'Offline',
  // 'operation': 'Operation',
  // operator: 'Operator',
  operation_time: 'Operation Time',
  // operation_type: 'Operation Type',
  // operation_records: 'Operation Records',
  // 'order': 'Order',
  _overview: ' Overview',

  // p
  // password: 'Password',
  // path: 'Path',
  'pending-install': 'Pending Install',
  physical_resource_usage: 'Physical Resource Usage',
  // p_i_pwd: "Please enter your Password",
  // p_i_username: 'Please enter username',
  // 'please_input_ ': 'Please input ',
  please_input_username: 'Please input username',
  please_input_keywords: 'Please input keywords',
  please_input_description: 'Please input description',
  pvc_disk: 'PVC Disk',
  'platform-management': 'Platform Management',
  pod: 'Pod',
  pod_restart_alarm: 'Pod Restart Events',
  pod_restart_alarm_desc: 'When a pod is restarted, a pod restart event will be generated, and the log before and after the pod is restarted will be recorded.The same pod is restarted several times, and only the last reboot log is recorded.',
  processing: 'Processing',
  // p_s_rc: 'Please select a country or region',

  // q
  // 'quota': 'Quota',
  quotas: 'Quotas',

  // r
  ready_total: 'Ready/Total',
  // refresh: 'Refresh',
  // 'remember_me': 'Remember me',
  request_limit: 'Request/Limit',
  resource_information: 'Resource Information',
  // resources_mgmt: 'Resource management',
  resource_overview: 'Resource Overview',
  resource_service: 'Service Management',
  resource_permissions: 'Resource Permissions',
  resources_permission_mgmt: 'Resource permission management',
  restart_time: 'Restart Time',
  // resources_permission_exist: 'Resource permission already exists',
  // resource_permissions_sub: 'Create, assign, and manage user resource permissions and roles',
  // 'role': 'Role',
  rootfs: 'Rootfs',
  router_management: 'Router Management',
  // 'rules': 'Rules',

  // s
  // save: 'Save',
  scale: 'Scale',
  // search: 'Search',
  // secret: 'Secret',
  service_name_in_secret: 'Service Name In Secret',
  shared_cluster: 'Shared Cluster',
  // 'sign_in': 'Sign In',
  // sign_in_sub: "Sign in to Developer Network",
  sign_in_to_developer_network: 'Sign in to Developer Network',
  // skip: 'Skip',
  sorry_no_app_permission: 'You are not subscribed to applications.',
  sorry_no_resource_permission: 'Sorry, no resource permission!',
  sorry_no_subscription_permission: 'Sorry, no subscription permission!',
  start_switch: 'start',
  // 'status': 'Status',
  stopped: 'Stopped',
  storage_resource_quota: 'Storage Resource Quota',
  // 'subscription_name': 'Subscription Name',
  // success_save: 'Saved successfully',
  // 'support_message': 'If you are experiencing issues and need technical support, please send an e-mail to',
  suspended: 'Suspended',
  svc: 'SVC',
  system_settings: 'System Settings',

  // t
  target_name: 'Target Name',
  // themes: 'Themes',
  the_name_has_been_taken: 'The name has been taken',
  // 'this_field_is_required': 'This field is required',
  // 'tickets': 'Tickets',
  total_service: 'Total',
  toolbox: 'Toolbox',
  toolbox_desc: "The toolbox provides config obtain and Web Kubectl's operating tools",
  // 'total_items': 'Total {value} items',
  // 'type': 'Type',

  // u
  unassign_quota: 'Unassign Quota',
  unbind: 'Unbind',
  // 'units': 'Units',
  // update_time: 'Update Time',
  usage_quota: 'Usage/Quota',
  // 'user': 'User',
  users: 'Users',
  // user_base_info: 'Basic information of users',
  // 'user_center': 'User Center',
  user_groups: 'User Groups',
  // user_info: 'User Information',
  // user_info_sub: 'Basic information and permissions of users',
  // username: 'username',
  // username_email: 'Username(Email)',

  // v
  // 'view': 'View',
  Version: 'Version',
  view_yaml: 'View Yaml',
  view_in_yaml: 'View in YAML',
  view_these_binded_key_and_export_them_quotas: 'View these binded {key} and Export them {quotas}',

  // w
  // 'web_kubectl': 'Web Kubectl',
  what_new: `What's New`,
  workloads_app_desc: 'Workloads belong to this application.',
  workloads_desc: 'Apps that users deploy in the namespace.',
  workspace_lower: 'workspace',
  // 'workspace': 'Workspace',
  workspace_unbind: 'Workspace(Unbind)',
  workspace_bind: 'Workspace(Bind)',
  workspace_create_tip: 'Only a-z 0-9 accepted, 16 letters maximum',
  workspace_create_tip_else: 'Only a-z, 0-9 . and - allowed',
  workspace_name: 'Workspace Name',
  workspaces: 'Workspaces',
  workspaces_desc:
    'A workspace is a logical unit of management namespace, resource management access, and shared resources internally, which can be used as a stand-alone workspace.',
  workspace_information: 'Workspace Information',
  workspace_status: 'Workspace Status',
  workspacequotas: 'workspacequotas ',
  workspacequota_lower: 'WorkspaceQuota',
  workspacequota: 'WorkspaceQuota',
  workspaceQuota: 'WorkspaceQuota',
  'workspace quotas': 'WorkspaceQuotas',
  workspace_quotas: 'WorkspaceQuotas',
  'workspace-quotas': 'WorkspaceQuotas',
  workspace_quotas_desc: 'WorkspaceQuotas are a mechanism used to limit the amount of user resources. Amount of resources used for management space.',
  workspace_scale_desc: 'Resources quota is used to restrict the user resources consumption of a mechanism, applied to workspace',
  workspace_usage_t5: 'Workspace Usage (Top 5)',
  '--without_quota--': '--Without Quota--',

  // =======================           MP Lite Portal           =======================
  access_url: 'Access URL',
  application_name: 'instance name',
  Application: 'Application',
  app_name: 'App Name',
  can_not_update: 'No newer version available',
  classification: 'Classification',
  cluster_not_found: 'Cluster not found.',
  gpu: 'GPU',
  package_name: 'service package name',
  redeploy: 'Redeploy',
  restart: 'Restart',
  service_package: 'Service Package',
  start: 'Start',
  start_app: 'Start the app',
  stop_app: 'Stop the app',
  sure_restart: 'Are you sure to restart this application.',
  sure_redeploy: 'Are you sure to redeploy this application.',
  sure_start: 'Are you sure to start this application.',
  sure_stop: 'Are you sure to stop this application.',
  sure_update: 'Are you sure to update this application.',
  unclassified: 'Unclassified',
  update_to_version: 'Update to {version}',
  usage: 'Usage',
  verify_sub: "For your security, we need to verify your identity. We've sent a code to the email.",
  workspace_id: 'Workspace ID',
  // Service Portal
  advanced_parameters: 'Advanced',
  aggregate: 'Aggregate',
  all_subscription: 'All Subscriptions',
  array: 'Array',
  authentication_database: 'Authentication Database',
  auto_input: 'Auto generate ID',
  back_to: 'Back to',
  bindable: 'Bindable',
  bind_model: 'Binding mode',
  body: 'body',
  boolean: 'Boolean',
  broker_bindable: 'Bindable',
  broker_display_name_tooltip: 'The service name displayed in the secret.',
  broker_plan_id: 'Plan ID',
  broker_service_id: 'Service ID',
  broker_url: 'Broker URL',
  canceling: 'Canceling',
  cancel_subscribe: 'Unsubscribe',
  cancel_success: 'Unsubscribe successful!',
  capacity: 'Capacity',
  charge_type: 'Charge Type',
  select_storage_class: 'Select storage class',
  cluster_type: 'Cluster Type',
  credentials: 'Credentials',
  create_broker_title: 'Add Service',
  create_DCCS: 'Create Service Key',
  create_pvc_radio1: 'Create dynamically with storage class',
  create_secret: 'Create Secret',
  create_secret_title: 'Secret Management',
  create_secret_subscription: 'Manage the secrets for connect to service',
  create_success_sp: 'Create successful!',
  creating: 'Creating',
  creation_time_mp: 'Created Time',
  dashboard_url: 'Dashboard URL',
  database_version: 'Database Version',
  dataService: 'PN Info',
  db_help_message: 'Only allowed to use a-z, A-Z, 0-9, "-", and must not start with "-". Length of {name} should be no more than 63 characters.',
  db_help_tooltip:
    '{name} is only allowed to use a-z, A-Z, 0-9, "-", and must not start with "-". Length of {name} should be no more than 63 characters. When left blank, a random name will be automatically generated.',
  db_name: 'Database Name',
  dccs_key: 'Service Keys',
  dccs_name: 'Service Key Name',
  delete_cluster: 'Delete Cluster',
  delete_instance_a: 'Are you sure you want to delete the instance? This action will not affect the database.',
  delete_instance_b: 'This action will delete the database used by this instance, are you sure?',
  delete_instance_c: 'Are you sure you want to delete the instance?',
  delete_service_broker: 'Items with the same service name and plan will also be deleted. Are you sure you want to delete this item?',
  delete_secret: 'Are you sure you want to permanently delete {secretName}?',
  delete_success: 'Delete successful!',
  deployment_name: 'Deployment Name',
  deployment_properties: 'Deployment Properties',
  detached: 'Detached',
  detach_cluster: 'Detach Cluster',
  detachedClusters: 'Detached Clusters',
  detachedInstances: 'Detached Instances',
  disable_success: 'Disable successful!',
  disable_mp: 'Disable',
  disabling: 'Disabling...',
  edit_DCCS: 'Edit',
  edit_instance: 'Edit Instance',
  update_secret: 'Update secrets',
  please_input_name: 'Please enter the {type} name',
  edit_instance_checkout_msg: 'Restart all the applications in the namespaces where the secrets are located',
  edit_success: 'Edit successful!',
  enable_success: 'Enable successful!',
  enabling: 'Enabling...',
  enter_any_value: 'Please enter any value for this field in a private cloud environment.',
  external_hosts: 'External Hosts',
  existing_storage_class: 'Existing storage class',
  form: 'Form',
  header: 'Header',
  host_role:
    'The format of this field is "{tag1}host{tag2}:{tag1}port{tag2}". If there are multiple "{tag1}host{tag2}:{tag1}port{tag2}", please separate with a comma (,).',
  input_regexp_1: 'Only [a-zA-Z0-9.-] allowed.',
  input_regexp_2: '. and - should not be at the beginning or at the end.',
  input_regexp_3: 'Only numbers are allowed.',
  input_regexp_4: 'Only [0-9a-f-]allowed.',
  input_regexp_5: 'Only [a-zA-Z0-9:-.,]allowed.',
  input_regexp_6: 'Only [a-z0-9.-] allowed.',
  input_regexp_7: 'Only [a-zA-Z0-9._-] and space allowed.',
  input_regexp_8: 'Only [a-zA-Z0-9._-] allowed.',
  input_regexp_9: 'Space is not allowed.',
  input_regexp_10: 'Only [a-zA-Z0-9_-.+] allowed.',
  input_regexp_11: 'Only [a-zA-Z0-9_-./@:] allowed.',
  input_regexp_12: 'This name is a reserved name, please use a different name.',
  input_regexp_13: 'Invalid plan name, please use a different name.',
  input_regexp_14: 'Only [a-zA-Z0-9.-] and [a-z] should be at the beginning.',
  instance_id: 'Instance ID',
  instance_list: 'Instance List',
  instance_name: 'Instance Name',
  instancesQuota: 'Instances Quota',
  integer: 'Integer ',
  internal_hosts: 'Internal Hosts',
  key: 'Key',
  key_repeat: 'Duplicate {keyEN} is not allowed.',
  loading_app_list: 'Loading app list...',
  location: 'Location',
  max_length: 'Must be no more than {length} characters.',
  name_repeat: 'A {name} with same name already exists.',
  namespace_not_found: 'Namespace not found.',
  monitoring: 'Monitoring',
  next_page: 'Next Page',
  no_cluster_found: 'No cluster found.',
  no_namespace_found: 'No namespace found.',
  no_storage_class: 'There is no storage class at present. To create PVC with storage class, you need to have at least one storage class',
  no_workspace_found: 'No workspace found.',
  no_instance: 'No Instance',
  no_pn: 'No PN',
  not_a_valid_UUID: 'Not a valid UUID.',
  notice_front_lite:
    'EnSaaS K8s Service Lite has been updated to version 4.1.5. Updated the page style, and moved the subscription dropdown menu down into page content. From EnSaaS-K8s-Service 4.0.11, EnSaaS-K8s-Service Lite has been split and merged Service Portal for the IoTSuite Edge scene. For more new features, please refer to ',
  overview_create_dedicated: 'Create Dedicated Cluster',
  overview_create_shared: 'Create Shared Cluster',
  // parameters: 'Parameters',
  persistent_disk_size: 'Persistent Disk Size',
  persistent_disk_type: 'Persistent Disk Type',
  persistent_volume: 'Storage',
  please_choose: 'Please choose',
  please_input_mp: 'Please input ',
  please_input_value: 'Please input {value}.',
  plan_sp: 'Plan',
  plan_name: 'Plan Name',
  prev_page: 'Previous Page',
  provider: 'Provider',
  pseudo_id: 'Pseudo ID',
  pv: 'PV',
  pv_desc:
    'PersistentVolume (PV) is a piece of storage in the cluster that has been provisioned by an administrator or dynamically provisioned using Storage Classes. It is a resource in the cluster just like a node is a cluster resource.',
  pvc: 'PVC',
  pvc_desc:
    'PersistentVolumeClaim (PVC) is a request for storage by a user. It is similar to a Pod. Pods consume node resources and PVCs consume PV resources. ',
  recreate: 'Recreate',
  recreating: 'Recreating...',
  recreate_secret: 'The secret ({secretName}) in the namespace will be recreated.  If the secret already exists, the secret will be replaced.',
  recreate_success: 'Recreate successful!',
  recycle_strategy: 'Reclaim policy',
  redeploy_failed: 'Redeploy failed!',
  redeploy_success: 'Redeploy successful!',
  remainInstances: 'Remaining Instances',
  remain: 'Remaining',
  rename: 'Rename',
  rename_instance: 'Rename',
  rename_instance_overview: 'Rename',
  rename_success: 'Rename successful!',
  resource_management: 'Resource Management',
  restart_all_apps_edit: 'Restart all associated apps after editing',
  resume_cluster: 'Resume Cluster',
  running: 'Running',
  runningClusters: 'Running Clusters',
  runningInstances: 'Running Instances',
  search_placeholder: 'Type and press ENTER to search {name}.',
  secrets: 'Secrets',
  secret_name: 'Secret Name',
  secret_management: 'Secret Management',
  series: 'Series',
  service_instance: 'Service Instances',
  service_instance_list: ' service instance list',
  service_instance_name: 'Service Instance Name',
  service_instance_id_tooltip: 'Generate a service instance ID.',
  service_key: 'Service Keys',
  service_list: 'Service list',
  service_list_subscription: 'Users can manage service instances in subscriptions',
  service_list_title: 'Instance List',
  service_management_subscription: 'Administrators can manage the services',
  service_management_title: 'Service Management',
  service_plan_name: 'Service Plan Name',
  service_usage: 'Service Usage',
  'service-usage-service-tooltip':
    'MongoDB and PostgreSQL only support the usage monitoring of shared plan instances; RabbitMQ only supports the usage monitoring of standard plan instances; EnSaaS-K8s-Service currently only supports the usage monitoring of Dedicated Cluster plan instances.',
  service_username: 'Username',
  ssl: 'SSL',
  scale_success: 'Scale successful!',
  scale_failed: 'Scale failed!',
  start_failed: 'Start failed!',
  start_success: 'Start successful!',
  stop_failed: 'Stop failed!',
  stop_success: 'Stop successful!',
  storage: 'StorageClass',
  storage_class_desc:
    'StorageClass provides a way for administrators to describe the "classes" of storage they offer. Mainly used to dynamically allocate PersistentVolume.',
  storage_statement: 'Storage statement',
  storage_volume: 'Storage volume',
  string: 'String',
  subscription_success: 'Subscription successful!',
  subscription_title: 'Create Instance',
  support: 'Support',
  support_content: 'If you are experiencing technical support issues, please send an e-mail to ',
  support_title: 'Contact Technical Support',
  sure_to_cancel: 'Are you sure you want to unsubscribe?',
  sure_to_disable: 'Are you sure you want to disable this item?',
  sure_to_enable: 'Are you sure you want to enable this item?',
  sure_to_recreate: 'Are you sure?',
  this_is_required: 'This field is required.',
  time_since_create: 'Time since created',
  totalActive: 'Active Clusters',
  totalClusters: 'Total Clusters',
  totalInactive: 'Inactive Clusters',
  totalInprogress: 'In Progress Clusters',
  total_mp: 'Total',
  transaction_id: 'Transaction ID',
  unlimited: 'Unlimited',
  update_failed: 'Update failed!',
  update_success: 'Update successful!',
  update_broker_title: 'Update Service',
  'user-defined-plan': 'User-defined Plans',
  userId: 'User ID',
  // value: 'Value',
  vhost_name: 'vhost Name',
  view_resource: 'View resource',
  visit_model: 'Access modes',
  vmSize: 'VM Size',
  vmType: 'VM Type',
  workspace_not_found: 'Workspace not found.',
  ':': ': ',
  // =======================           sso           =======================

  // a
  account_owners: 'Account Owners',
  accounts: 'Accounts',
  active_sso: 'Active',
  active_zh: 'Active',
  add_enterprise: 'Add enterprise',
  add_enterprise_user: 'Add enterprise administrator',
  add_to_sub: 'Add to subscription',
  add_sub: 'Add subscription',
  add_sub_user: 'Add a subscription user',
  adjustment: 'Adjustment',
  admin_sso: 'Admin',
  all_sub: 'All Subscriptions',
  all_enterprise: 'All Enterprises',
  all_normal_sub: 'All Paid Subscriptions',
  app_id: 'App ID',
  app_role: 'APP Role ',
  app_permissions: 'App Permissions',
  available_points: 'Available Point',
  available_credit: 'Available Credit',

  // b
  balance: 'Balance',
  bind_phone: 'Binding mobile phone',
  bind_phone_title: 'Binding Mobile Phone',
  bind_phone_info: 'This feature is currently only in trial operation in mainland China',

  // c
  change_pwd_by_policy: 'Please change the password according to the policy',
  client_sso: 'Client',
  clients_sso: 'Clients',
  client_edit: 'Edit client information',
  client_id: 'Client ID',
  client_name: 'Client Name',
  client_role: 'Client Role',
  client_sub: 'Attention: The page operations depend on your permissions in org.',
  client_s: 'Client created successfully!',
  client_s_sub: 'Please keep your clinent ID and security code properly.',
  client_s_notice: 'You will only be able to view this key here once! It is not stored in this form. So be sure to copy it now.',
  client_normal: 'Platform Deployment Application Client',
  client_oauth: 'OAuth Client',
  client_trust: 'Managed Service Clients',
  client_user: 'SRP User',
  client_user_info: 'Manage users under the client',
  clusterAdmin: 'Cluster Admin',
  clusterOwner: 'Cluster Owner',
  common_app: 'Common App',
  complete: 'Complete',
  cost_center: 'Cost Center',
  create_client: 'Create Client',
  create_client_sub: 'Enter client information',
  create_retry_sso: 'SSO account creation failed, please try again!',
  create_success_sso:
    'The SSO account was created successfully. You will receive an EnSaaS SSO account registration letter. Please change the password in time according to the information in the registration letter. ',
  creation: 'Creation',
  creation_time_sso: 'Created at',
  creator: 'Creator',
  crmid: 'CRM ID',
  current_hosting_status: 'Current Hosting Status',

  // d
  datacenterAdmin: 'Data Center Admin',
  delete_subscription: 'Are you sure you want to delete {name}?',
  delete_sub_role: 'Are you sure you want to delete the permission of subscription {name}?',
  delete_with_name: 'Are you sure you want to delete {name}?',
  discount_record: 'Discount Rate Change Record',
  document_sso: 'DOC',
  document_api: 'API Document',

  // e
  email_s: 'email',
  ensaas: 'EnSaaS',
  enterprise_account: 'Enterprise',
  enterprise_account_sub: 'The enterprise administrator can establish a subscription under the enterprise and manage the users under the subscription',
  enterprise_export: 'Enterprises Export',
  enterprise_user: 'Enterprise User',
  enterprise_user_sub: 'Set up an enterprise administrator',
  enterpriseAdmin: 'Enterprise Admin',
  enter_member: 'Of Subscription',
  expenses_record: 'Available Credit Change Record',

  // f

  // g
  globalAdmin: 'Global Admin',
  go_creation: 'Go Creation',
  go_mgmt: 'Go Management',
  go_to_change_pwd_sso: 'Go to change password',

  // h
  hosting: 'Hosting',
  hosting_deal_subscription:
    'You have received {count} hosting processing requests from the subscription admin. Click OK to proceed to the Subscription page for processing. Or go to [Subscription] [Operations] [Hosting] for processing later. ',
  hosting_deal_enterprise:
    'You have received {count} hosting processing requests from the enterprise Admin Click OK to proceed to the Subscription page for processing. Or go to [Subscription] [Operations] [Hosting] for processing later. ',
  hosting_deal_both:
    'You have received {subCount} hosting processing requests from the subscription admin and {epCount} hosting processing requests from the enterprise Admin. Click OK to proceed to the Subscription page for processing. Or go to [Subscription] [Operations] [Hosting] for processing later. ',
  hosting_state: 'Hosting State',
  hosting_record: 'Hosting Record',

  // i
  identity_record: 'Identity Change Record',
  identity_before: 'Role before operation',
  identity_after: 'Role after operation',
  info_safe: 'We will not disclose your phone information',
  invite_user_sso: 'User already exist ,would you like to invite this user to your cluster or workspace?',
  is_paid_account: 'Is Paid',
  is_internal: 'Is Internal',

  // j

  // k

  // l
  last_modify_time: 'Last modefied time',

  // m
  mgmt: 'Management',
  management_user: 'Manage Users',
  management_user_info: 'Manage all users, including adding, deleting, enabling and disabling etc.',
  member_type: 'Member Type',
  m_detail: 'Detail',
  modify: 'Modify',
  modify_phone: 'Modify Phone',
  my_profile: 'Profile',

  // n
  name_crmid: 'Name（CRM ID）',
  namespaceDeveloper: 'Namespace Developer',
  new_pwd: 'New password',
  new_pwd_confirm: 'New Password Confirmation',
  no: 'No',
  not_remain_again: "Don't show it next time",

  // o
  operating_time: 'Operating Time',
  operating_points: 'Operating Points',
  // operation_record: 'Operation Records',
  operation_record_sub: 'Record key deletion, addition, modification and other operations',
  // operation_type: 'Operation Type',
  operation_total_points_before: 'Total points before operation',
  ope_target_type: 'Operation Type',
  ope_target_name: 'Target Name',
  ope_action: 'Action',
  ope_operator_name: 'Operator',
  ope_target_identity: 'Target Role',
  ope_create_time: 'Operation Time',
  ope_target_id: 'Target ID',
  ope_description: 'Description',

  // p
  permission: 'Permission',
  p_i_app_id: 'Please enter App ID',
  p_i_service_name: 'Please enter service name',
  p_i_user_id: 'Please enter user ID',
  p_i_integer: 'Please enter an integer',
  p_i_city: 'Please enter your city',
  p_i_client_name: 'Please enter client name',
  p_i_crmid: 'Please enter CRM ID',
  p_i_company: 'Please enter a company',
  p_i_sub_company: 'Please enter company name',
  p_i_redirect: 'Please enter redirect url',
  p_i_scopes: 'Please enter authority, E.g: admin,user',
  p_i_sub_name: 'Please enter subscription name',
  p_i_sub_short_name: 'Please enter subscription name',
  p_i_sub_rate: 'Please set the exchange rate between WISEPoint and the selected currency',
  p_i_enterprise_name: 'Please enter an enterprise',
  p_i_quota_point: 'Please enter available credit',
  p_i_sub_id: 'Please enter subscription ID',
  p_i_trust_key: 'Please enter trust key',
  p_i_valid_url: 'Please enter a valid URL',
  p_i_verify_code: 'please enter verification code',
  // p_i_phone: 'Please enter the phone number',
  p_s_dc: 'Please select a data center',
  p_s_cluster: 'Please select a cluster',
  p_s_ws: 'Please select a workspace',
  p_s_ns: 'Please select a namespace',
  p_s_mt: 'Please select a member type',
  p_s_sub: 'Please select a subscription',
  p_s_enterprise: 'Please select an enterprise',
  phone: 'Phone',
  phone_s: 'phone',
  phone_number: 'Phone Number',
  points_spent: 'Points Spent',
  points_credit: 'Points Credit',
  points_available: 'Available Point',
  points_available_trail: 'Available Credit Points',
  points_total: 'Point Total',

  // q
  quota_point: 'Consumption Limit',

  // r
  record_OpenHosting: 'Entrusted hosting',
  record_CloseHosting: 'End hosting',
  record_OpenHostingRequest: 'Request hosting',
  record_CloseHostingRequest: 'Cancel hosting request',
  record_ChangeHostingRequestPass: 'Request hosting was passed',
  record_ChangeHostingRequestReject: 'Request hosting was rejected',
  redirect_url: 'Redirect Url',
  // remove: 'Remove',
  remove_user: 'Are you sure you want to remove {name} from the subscription?',
  remove_users: 'Are you sure you want to remove these users?',
  remove_email: 'Are you sure you want to remove {name}?',
  resources_permission: 'Resource Permissions',
  roles: 'Roles',
  roles_introduction: 'Roles Introduction',
  roles_sub: 'User role description',
  role_ga: 'Global Admin',
  role_ga_des:
    'An admin who oversees EnSaaS data centers worldwide with the highest privilege level that permits them to designate admins for data centers, admins for clusters, and roles for tenant spaces. The admin is allowed to manage EnSaaS subscriptions by creating such subscriptions and binding a user to any of the subscriptions.',
  role_da: 'DataCenter Admin',
  role_da_des:
    'An admin who oversees a data center with the highest privilege level that permits them to manage resources within all clusters for the data center, designate admins for clusters and roles for tenant spaces. The admin is allowed to manage EnSaaS subscription by creating such subscriptions and binding a user to any of the subscriptions.',
  role_ca: 'Cluster Admin',
  role_ca_des:
    'An admin who oversees a Kubernetes cluster with the highest privilege level that permits them to manage all workspaces and namespaces, all applications deployed in the cluster, and all Kubernetes resources within the cluster. The admin can designate roles for tenant spaces but cannot manage EnSaaS subscriptions.',
  role_co: 'Cluster Owner',
  role_co_des:
    'The owner of a dedicated cluster who manages the tenant spaces within the cluster. They can access the cluster, managing all the workspaces and namespaces of the cluster, the applications deployed by tenants within the cluster, certain Kubernetes resources within the cluster, and designate roles for the workspaces and namespaces. They cannot subscribe to, upgrade, downgrade, or unsubscribe from the cluster. ',
  role_wo: 'Workspace Owner',
  role_wo_des:
    'The owner of a general workspace or a workspace built within a dedicated cluster. They are in charge of the tenant spaces within a workspace and can access the workspace and manage all namespaces within the workspace, all tenant-deployed applications within the workspace, and certain Kubernetes resources (and have access to these resources). They can designate roles for namespaces but cannot subscribe to, upgrade, downgrade, or unsubscribe from the workspace.',
  role_nd: 'Namespace Developer',
  role_nd_des:
    'The developer of a namespace. They can access the namespace and all applications deployed within the namespace and manage certain Kubernetes within the namespace.',
  role_s_sa: 'Subscription Admin',
  role_s_sa_sub:
    'The admin of an EnSaaS subscription. An EnSaaS subscription is bound to a MyAdvantech account. The admin can subscribe to, upgrade or downgrade, and unsubscribe from a product, service, or resource (all of which are referred to cloud services) on the EnSaaS platform. The admin can manage or access a cloud service on the EnSaaS platform they have subscribed to. The admin can also manage orders and bills for cloud services.',
  role_s_su: 'Subscription User',
  role_s_su_sub:
    'A user of a subscription. The user can manage and access the cloud services covered in the subscription but cannot subscribe to any cloud service, unsubscribe from the service, or manage an order or bill for the service.',
  role_srp_u: 'SrpUser',
  role_srp_u_sub:
    'The user of a cloud-based application. They can access the application, and their role is assigned by the visitor to the application who has the highest privilege. They cannot access any EnSaaS tenant space. ',
  role_not_insert_sso: 'You have a subscription permission information has not been added to the permission list, do you need to return to modify?',

  // s
  scopes: 'Authority',
  security_code: 'Client Secret',
  send_pwd_email_sub_sso:
    'If you forget your password, you can use this tool to reset your password. After submission, you will receive an email or mobile verification code with a link to complete the process.',
  send_pwd_phone_success: 'Send password reset SMS successfully. Page will be redirecting after 5 seconds.',
  send_verify_code_again: 'Resend in {name} seconds',
  select_sub: 'Select a subscription',
  signOut: 'Sign out',
  srp: 'Srp',
  srpUser: 'SRP User',
  sso_permissions: 'SSO Permissions',
  success_delete: 'Deleted successfully',
  success_insert: 'Added successfully',
  subscription_details: 'Subscription Details',
  subscription_export: 'Subscriptions Export',
  subscription_mgmt: 'Subscription Management',
  subscription_user: 'Subscription User',
  subscription_id_sso: 'Subscription ID',
  subscription_sub: 'Subscription management, information viewing',
  subscription_detail: 'Manage users under the subscription',
  subscription_type: 'Subscription Type',
  subscription_id_role: 'Subscription Role',
  subscriptionAdmin: 'Subscription Admin',
  subscriptionUser: 'Subscription User',
  subscribed_permissions: 'Subscribed Permissions',
  subscribed_permissions_up: "Are you sure to elevate the user's permission to Subscription Admin? ",
  subscribed_permissions_down: "Are you sure to demote the user's permissions to Subscription User? ",
  sub_basic: 'Basic Information',
  sub_role: 'Permission Configuration',
  sub_rate_prompt1: 'The current discount rate ({name}% off) is still valid until the end of the month.',
  sub_rate_prompt2: 'The new discount rate will become effective next month.',
  sub_cost: 'Cost Configuration',
  sub_short_name: 'Subscription Name',
  sub_company: 'Company Name',
  sub_shared_discount: 'Shared Member Discount',
  sub_allow_billing: 'Allow Access To Billing Portal',
  sub_service_trust: 'Request Hosting Service',
  sub_service_trust_info: 'If you choose to enable, you will receive a escrow authorization request when the subscription admin logs in',
  sub_top_cost: 'Current Available Credit',
  sub_billing_unit: 'Expense Billing Unit',
  sub_billing_unit_info:
    'After setting the exchange rate between WISEPoint and the selected currency, the bill of the subscription account will be presented at this exchange rate',
  sub_discount_rate: 'Discount Rate',
  sub_effective_discount: 'Effective Discount Rate',
  sub_exchange_rate: 'Exchange Rate',
  sub_enter_admin: 'Enterprise Admin',
  sub_guest_deal_request_choose_no: 'No, I manage my service on my own.',
  sub_guest_deal_request_choose_yes: 'Yes, the admin can host my service and access my data.',
  sub_guest_deal_request_choose: 'Do you wish your enterprise admin to host your service?',
  sub_guest_deal_request_label: 'Requested by',
  sub_guest_deal_request_for_label: 'Request for',
  sub_guest_deal_request_msg: 'Your enterprise admin has sent you a request for hosting your service. Please response below.',
  sub_guest_denied_msg: 'Subscription admin has denied your hosting authrity.',
  sub_guest_accept_msg: 'Your service hosting request has been accepted.',
  sub_guest_reject_msg: 'Your service hosting request has been rejected.',
  sub_guest_denied_label: 'Authority denied by',
  sub_guest_denied_form_label: 'Subscription',
  sub_guest_hosting_label: 'Your service is current hosted by the enterprise admin',
  sub_guest_unhosted_label: 'Your service is not hosted by the enterprise admin',
  sub_guest_configure: 'Configure Hosting Status',
  sub_guest_configure_no: 'The admin cannot host my service and access my data',
  sub_guest_configure_yes: 'The admin can host my service and access my data',
  sub_guest_prompt: 'You can change the status from below',
  sub_guest_request_label: 'Authority granted by',
  sub_guest_accept_label: 'Request accepted by',
  sub_guest_reject_label: 'Request Rejected by',
  sub_guest_request_msg: 'Subscription admin has granted you hosting authrity.',
  sub_guest_request_title: 'You can change your hosting setting below',
  sub_hosting: 'Hosting',
  sub_hosting_basic: 'Basic Information',
  sub_hosting_req_process: 'Request Processing',
  sub_hosting_status: 'Hosting Status',
  sub_hosting_action: 'Hosting Action',
  sub_hosting_unhost: 'Unhosted',
  sub_hosting_hosted: 'hosted',
  sub_hosting_hosting: 'Hosting',
  sub_hosting_stop: 'Stop',
  sub_hosting_await_process: 'Request To Be Processed',
  sub_hosting_none: 'None',
  sub_hosting_process_sponsor: 'Request Initiator',
  sub_hosting_current_identity: 'Operator Identity',
  sub_hosting_request_initiator_identity: 'Request Initiator Role',
  sub_hosting_process_status: 'Request Status',
  sub_hosting_pending_request: 'Pending Request',
  sub_hosting_requesting: 'Requesting',
  sub_hosting_requested: 'Requested',
  sub_hosting_denied: 'Denied',
  sub_hosting_request: 'Subscription Account Hosting Request',
  sub_hosting_no_permission: 'The subscription has a pending request, and there is no action available for your identity',
  sub_host_cancel_request_choose_no: 'Wait for the subscription admin response',
  sub_host_cancel_request_choose_yes: 'Cancel the request',
  sub_host_cancel_request_choose: 'Or you may cancel the request',
  sub_host_cancel_request_label: 'Request sent to',
  sub_host_cancel_request_msg: "Your request for hosting the sub-subscription's service has been sent. Please wait for response",
  sub_host_request_title: 'You can request your sub-subscription for hosting services',
  sub_host_request_prompt: "You are not allowed to host your sub-subscription's service",
  sub_record: 'Subscription Record',
  sub_record_point_consumption: 'Point Consumption',
  sub_record_point_limit_change: 'Available Credit Change',
  sub_record_hosting_record: 'Hosting Request',
  sub_action: 'Action',
  sub_action_agree: 'Agree',
  sub_action_refuse: 'Rejected',
  sub_record_before_action: 'Pre-operation Value',
  sub_record_after_action: 'Value After Operation',
  sub_record_used: 'Used',
  sub_record_remain: 'Remaining',
  sub_record_time: 'Time',
  sub_record_approver: 'Approver',
  sub_record_approver_identity: 'Approver Identity',
  sub_record_requester: 'Operator',
  sub_record_requester_identity: 'Operator identity',
  sub_record_quota_title: 'Available Credit Change Record',
  sub_record_quota_sub_title: 'Subscription consumption record and available credit change record',
  sub_record_hosting_title: 'Hosting Record',
  sub_record_hosting_sub_title: 'Subscription hosting change record',
  sub_point_not_set: 'Unlimited',
  support_info: 'If you are experiencing technical support issues, please send an e-mail to ',
  system_sitting: 'System Settings',

  // t
  tenant_space_role: 'Tenant Space Role',
  trust_key: 'Trust Key',
  time_expire: 'Expire Time',
  time_inactive: 'Inactive Time',
  time_freeze: 'Release Time',
  time_formal: 'Positive date',

  // u
  used_and_limit: 'Used/Limit',
  user_exist_in_sub: 'User already exist in this subscription',
  user_u: 'Users',
  user_l: 'users',
  user_manual: 'User Manual',
  user_not_found: 'User does not exist',
  user_management_sub: 'Create, assign, and manage user subscription permissions and roles',
  unauthorized: 'Unauthorized. Please login again',
  unassigned: 'unassigned',
  unrestricted: 'Unrestricted',
  unconsumed: 'Unconsumed',

  // v
  verify_sub_sso: "For your security, we need to verify your identity. We've sent a code to the {name}{change}.",
  verify_code_error: 'Verification code format error',
  verify_code_policy: "Didn't receive the SMS verification code? ",
  verify_code_p_1: '1. There is a delay in the phone verification code, it may take 2-3 minutes to receive, please try again later. ',
  verify_code_p_2:
    "2. If you still haven't received it after 2-3 minutes, check if your phone has stopped serving, or intercepted our text messages, or your SMS inbox is full. ",
  verify_code_p_3: '3. You can try moving your SIM card to another phone, try again, or contact your phone carrier for advice. ',
  verify_code_p_4: '4. When your phone is lost, deactivated, or not around, it is recommended that you change other verification methods. ',
  verify_identidy: 'Verify Identity',
  vip_identity: 'Member Type',

  // w
  workspaceOwner: 'Workspace Owner',
  wise_point: 'Points',

  // x

  // y
  yes: 'Yes',

  // z

  // =======================          DB Backup & Restore          =======================
  backup: 'Backup',
  backup_name: 'Backup Name',
  backup_id: 'Backup ID',
  db_restore_id: 'Restore ID',
  input_restore_id: 'restore ID',
  input_backup_id: 'backup ID',
  backup_configuration: 'Backup Configuration',
  lowercase_backup_configuration: 'Backup configuration',
  backup_management: 'Backup Management',
  restore_management: 'Restore Management',
  backup_schedule: 'Backup Schedule',
  lowercase_backup_schedule: 'Backup schedule',
  backup_scheduler: 'Schedule Calendar',
  start_time: 'Backup Start Time',
  end_time: 'Backup End Time',
  backup_size: 'Backup Size',
  backup_type: 'Backup Type',
  full_backup: 'Full backup',
  select_database_backup: 'Select the databases to backup',
  backup_type_full: 'Backup all databases',
  backup_type_individual: 'Specify database to backup',
  backup_type_individual_desc: 'Please select the database',
  all_services: 'All Services',
  no_instances: 'No Instances',
  all_status: 'All Status',
  done: 'Done',
  backing_up: 'Backing Up',
  all_type: 'All Types',
  Full: 'Full',
  individual: 'Individual',
  immediate_backup: 'Immediate Backup',
  backup_config_desc: 'Use existing backup configuration',
  destination_storage: 'Choose a storage as backup destination',
  destination_storage_validate: 'Do not find any storage. Please add at least one storage first.',
  advanced: 'Advanced',
  backup_period: 'Period',
  shard: 'Shard',
  retention: 'Retention Policy',
  shard_id: 'shard ID',
  retention_placeholder: 'Retention Policy Name',
  backup_duration: 'Backup Duration',
  restore_duration: 'Restore Duration',
  trigger_mode: 'Trigger Mode',
  selected_database: 'Selected Database',
  storage_name: 'Storage Name',
  storage_type: 'Storage Type',
  advanced_information: 'Advanced Information',
  view_log: 'View Log',
  save_settings: 'Save the current settings as a new backup configuration',
  // batch_delete: 'Batch Delete',
  batch_delete_msg: 'Are you sure to delete the selected',
  data: ' item(s)?',
  restore: 'Restore',
  stop_backup: 'Stop Backup',
  stop_backup_msg: 'Are you sure to stop backup?',
  restore_confirmation: 'Restore Confirmation',
  restore_information: 'Restore Information',
  restore_policy: 'Restore Policy',
  overwriting_database: 'Make the restore overwriting existing databases',
  creating_database: 'Make the restore creating the new databases',
  restore_note: `#### Please Note:\n1. You cannot perform other backup or restore tasks during the restoring process.\n2. If there are backup tasks scheduled to start during the restoring process, the tasks will be skipped.`,
  configuration_name: 'Configuration Name',
  backup_destination_storage: 'Storage Name',
  restore_start_time: 'Restore Start Time',
  restore_end_time: 'Restore End Time',
  schedule_name: 'Schedule Name',
  frequency: 'Frequency',
  start_backup: 'Confirm to Start Backup',
  start_backup_with_configuration: 'Start backup with the following backup configuration',
  start_according_settings: 'The backup will start according to the following settings',
  edit_config: 'Edit Backup Configuration',
  delete_config: 'Delete Backup Configuration',
  delete_remark: 'The following schedule is using this backup configuration:',
  delete_remark_s: 'The following schedules are using this backup configuration:',
  delete_warn: 'Please delete the dependent schedule(s) before deleting the backup configuration.',
  confirm_delete_no_schedule: 'Are you sure to delete the backup configuration {name}?',
  restore_details: 'Restore Details',
  backup_details: 'Backup Details',
  stop_restore: 'Stop Restore',
  stop_restore_msg: 'Are you sure to stop restore {item}?',
  add_backup_schedule: 'Add Backup Schedule',
  backup_every: 'Backup every',
  start_at: 'Start at',
  edit_backup_schedule: 'Edit Backup Schedule',
  cron_time: 'Cron Time',
  enable_backup_schedule: 'Enable Backup Schedule',
  disable_backup_schedule: 'Disable Backup Schedule',
  enable_backup_schedule_msg: 'Are you sure to {type} the backup schedule {item}?',
  storage_settings: 'Storage Settings',
  confirm_to_storage_settings: 'Confirm to leave this page and go to the {type}?',
  add_storage: 'Add Storage',
  region: 'Region',
  access_key: 'Access Key',
  secret_key: 'Secret Key',
  test_connection: 'Test Connection',
  // endpoint: 'Endpoint',
  signature_version: 'Signature Version',
  NFS_version: 'Version',
  NFS_service: 'NFS Service',
  remote_path: 'Remote Path',
  edit_storage: 'Edit Storage',
  edit_description_placeholder: 'Please input description',
  download_error: 'Download failed.',
  configuration: 'Configuration',
  schedule: 'Schedule',
  manual: 'Manual',
  storage_backup: 'Storage',

  connection_successful: 'Connection Successful!',
  connection_failed: 'Connection Failed!',
  add_config: 'Add Backup Configuration',
  instance: 'instance(s)',
  cron: 'Cron Expression',
  no_log: 'No log data.',
  restore_warn_title: 'There is a {type} operation running',
  restore_warn_content: 'Please wait and try again.',
  back_today: 'Today',
  schedule_day: 'Day',
  source_database: 'Source Database',
  new_database_name: 'New Database Name',
  all_database: '<All Databases>',

  // Cron component
  week: 'Week',
  cron_month: 'Month',
  Mon: 'Monday',
  Tue: 'Tuesday',
  Wed: 'Wednesday',
  Thu: 'Thursday',
  Fri: 'Friday',
  Sat: 'Saturday',
  Sun: 'Sunday',
  Jan: 'January',
  Feb: 'February',
  Mar: 'March',
  Apr: 'April',
  May: 'May',
  Jun: 'June',
  Jul: 'July',
  Aug: 'August',
  Sep: 'September',
  Oct: 'October',
  Nov: 'November',
  Dec: 'December',
  cron_start_time: 'Start Time',
  cron_end_time: 'End Time',
  time_interval: 'Time Interval',
  specify: 'Specify Time',
  timing_schedule: 'Timing Schedule',
  expiry_days: 'Expiry Days',
  expiry_time: 'Expiry Time',
  custom_config: 'Custom configuration',
  schedule_warn: 'The running backup may fail after deleting this backup schedule.',
  delete_schedule_msg: 'Are you sure to delete the backup schedule {name}?',
  time_warn: 'The start time must be earlier than the end time.',
  backup_configuration_validate: 'Backup configuration cannot be empty. Please add backup configuration first.',
  instance_info: 'Instance Information',
  no_upcoming_schedule: 'No Schedule',
  database_services: 'Database Services',
  instance_status: 'Instance Status',
  upcoming_schedule: 'Upcoming Schedule',
  max_name_length: 'Must be less than {length} characters.',
  backup_regexp_1: 'Only [a-zA-Z0-9-] and beginning with a letter or number allowed.',
  backup_regexp_2: 'Only [a-zA-Z0-9.-] and beginning and ending with a letter or number allowed.',
  backup_regexp_3: 'Space is not allowed.',
  delete_backup_management: 'Delete Backup',
  delete_restore_management: 'Delete Restore Job',
  restore_job: 'restore job',
  delete_storage: 'Delete Storage',
  delete_backup_restore_msg: 'Are you sure to delete the {type}?',
  is_deleted: 'Deleted',
  backup_disable: 'Disable',
  specify_destination: 'Specify the restore destination',
  all_databases: '<All Databases>',
  test_connection_text: 'Test connection',
  delete_backup_schedule: 'Delete Backup Schedule',
  backup_info: 'Backup Information',
  schedule_info: 'Schedule Information',
  source_all_warn: 'The restored instance must be in initial state. If there is already a database in the instance, please remove it first.',
  restore_error_warn: 'After the database is restored, the secret needs to be created manually before the app can connect.',
  protocol_title: 'User Database Backup and Restore Service Agreement',
  protocol_label: 'Please read the following service agreement carefully, and you can use the database backup and restore service provided by WISE-IoTSuite when agreeing to this agreement.',
  backup_warn: 'Backup source database only allow [a-zA-Z0-9.-] and beginning with a letter or number, and must be less than 63 characters.',

  // =======================           KubeIot Portal           =======================

  device: 'Device',
  latest_data: 'Latest Data Reported',
  view_property: 'View Property',
  devices_devices_detail: 'Devices / Devices Detail',
  summary: 'Summary',
  subdevice: 'Sub-device',
  tag: 'Tag',
  tags: 'Tags',
  device_shadow: 'Device Shadow',
  device_shadow_tip:
    'The device shadow is a JSON file that stores properties reported by the device and properties that the platform expects to deliver to the device. You can run commands, deliver configurations, or directly modify data on this page to modify device properties. If the modification cannot be delivered due to a device exception or because the device is offline, the modification takes effect after the device comes online. If data reported by a device is binary code streams, the platform encrypts the data using a Base64 algorithm, and the reported value is displayed as the encrypted data.',
  command: 'Command',
  device_link: 'Device Link',
  devices_detail: 'Devices Detail',
  devices: 'All Devices',
  all_devices: 'All Devices',
  devices_desc: 'Devices Description',
  device_status: 'Device Status',
  client_key: 'Client Key',
  device_auth_type: 'Device Auth Type',
  product: 'Product',
  group: 'Group',
  please_select_product: 'Please Select Product',
  please_select_device: 'Please Select Device',
  protocol_type: 'Protocol Type',
  data_format: 'Data Format',
  product_name: 'Product Name',
  product_id: 'Product ID',
  products_list: 'Products',
  products_list_desc: 'On the IoT platform, a product is a collection of devices with the same capabilities or features.',
  device_type: 'Device Type',
  smart_manufacturing: 'Smart Manufacturing',
  smart_industry: 'Smart Industry',
  smart_medicine: 'Smart Medicine',
  smart_retail: 'Smart Retail',
  smart_park: 'Smart Park',
  others: 'Others',
  manufacturer: 'Manufacturer',
  create_product: 'Create Product',
  reset_secret: 'Reset Secret',
  device_name: 'Device Name',
  device_id: 'Device ID',
  gateway_id: 'Gateway ID',
  device_twin: 'Device Twin',
  item_tips: '{item} Tip',
  command_tip:
    'If the product that the device belongs to has defined commands, you can call the platform APIs or click Deliver Command to deliver a command. Currently, MQTT devices support synchronous command delivery, and NB-IoT devices support asynchronous command delivery.',
  synchronous_command_delivery: 'Synchronous Command Delivery',
  sync_deliver_command: 'Sync Deliver Command',
  asynchronous_command_delivery: 'Asynchronous Command Delivery',
  async_deliver_command: 'Async Deliver Command',
  queued_commands: 'Queued Commands',
  historical_commands: 'Historical Commands',
  device_secret: 'Device Secret',
  // products: 'Products'
  // update_time: 'Update Time',
  // secret: 'Secret',
  device_information: 'Device Information',
  access_information: 'Access Information',
  data_escalation: 'Data escalation',
  authentication_type: 'Authentication Type',
  gateway: 'Gateway',
  authentication_type_tip: `Device authentication ensures secure connection to the platform and secure management.
    Use a secret for dentity authentication.
    Use an x.509 certificate for identity authentication.`,
  add_sub_device: 'Add Child Device',
  sub_device_tip:
    'Devices (sensors) connected to the platform through gateways are displayed. The status of a child device indicates the access status to the gateway, and the gateway reports the status to the platform for updating. If the gateway cannot report the status of a child device, the child device status on the platform is not updated. ',
  certification_type: 'Certification Type',
  view_history_data: 'View History Data',
  reset_secret_tip:
    'After the secret is reset, the original secret becomes invalid. The new secret must be updated on the device, and the device must carry the new secret for authentication during platform connection. You can specify a new secret in the text box below. If you do not specify a new secret, the platform automatically generates one. ',
  new_secret: 'New Secret',
  new_secret_tip: 'If you do not specify this parameter, the platform automatically generates a new secret.',
  confirm_new_secret: 'Confirm New Secret',
  reset_name: 'Reset Name',
  no_command_parameters: 'No command parameters.',
  duration: 'Duration',
  choose_command: 'Choose Command',
  delivery_policy: 'Delivery Policy',
  cache_duration: 'Cache Duration',
  bind_tags: 'Bind Tags',
  bind_tags_tip: 'Bind tags to make it easier to find specific devices.',
  tag_value: 'Tag Value',
  add_tag: 'Add Tag',
  desired_value: 'Desired Value',
  configure_property: 'Configure Property',
  device_secert: 'Device Secert',
  direct: 'Direct',
  sync_command: 'Deliver Command',
  async_command: 'Deliver Command',
  node_id: 'Node ID',
  // node_type: 'Node Type',
  unbind_tip: 'Are you sure you want to unbind this tag?',
  use_sub_info: 'Please use the information for setting connection and information reporting',
  device_detail: 'Device Detail',
  delete_bind_info: 'Are you sure you want to unbind this tag?',
  delete_sub_device_info: 'Are you sure you want to delete this device? (This operation cannot be undone.)',
  revoke: 'Revoke',
  delete_revoke_info: 'Are you sure you want to revoke the desired property value?',
  immediate_delivery: 'Immediate Delivery',
  these_two_secrets_do_not_match: 'These two secrets do not match.',
  group_id: 'Group ID',
  command_type: 'Command Type',
  command_id: 'Command ID',
  command_name: 'Command Name',
  send_time: 'Send Time',
  finish_time: 'Finish Time',
  access_mode: 'Access Mode',
  reported_value: 'Reported Value',
  desire_value: 'Desire Value',
  registered_devices: 'Registered devices',
  product_detail: 'Product Detail',
  property_command: 'Module',
  module_property: 'Property',
  module_event: 'Event',
  service_command: 'Command',
  product_module: 'Module',
  product_module_property: 'Property',
  product_module_event: 'Event',
  product_module_command: 'Command',
  device_property_name: 'Property Name',
  delete_module: 'Delete Module',
  value_range: 'Value Range',
  unit: 'Unit',
  length: 'Length',
  size: 'Size',
  item_type: 'Item Type',
  device_command_name: 'Command Name',
  device_command_params: '	Downlink Parameter',
  device_command_responses: '	Response Parameter',
  edit_module: 'Edit Module',
  edit_property: 'Edit Property',
  edit_command: 'Edit Command',
  edit_event: 'Edit Event',
  data_type: 'Data Type',
  param_data_name: 'Param Data Name',
  response_data_name: 'Response Data Name',
  device_service_name: 'Module Name',
  device_event_name: 'Event Name',
  event_type: 'Event Type',
  device_topo_map: 'Device Topology',
  cloud: 'Cloud',
  edge_clouds: 'Edge Clouds',
  topic_list: 'Topic List',
  communication_topic: 'Communication Topic',
  other_communication_topic: 'Other Communication Topic',
  self_communication_topic: 'Self Communication Topic',
  device_group: 'Device Group',
  json_invalidate: 'Json is invalidate',
  upload_device_ext: 'Upload device info',
  fit_view: 'Fit View',
  fit_center: 'Fit Center',
  fit_tip: "Can't see ? Try executing the following two functions",
  overviews: 'Overview',
  collect_interval: 'Collect Interval',
  report_interval: 'Report Interval',
  extension_config: 'Extension Config',
  data_synchronism: 'Data Synchronism',
  set_device_ext_info: 'Device extension info',
  device_ext_info_tip:
    'You can quickly set up extension information by importing files, and the platform supports Json format conversion to device extension information content. For a quick import, write the file according to the template below.',
  device_ext_info_module: 'Device Extension Module',
  upload_file: 'Upload File',
  device_data: 'Device Data',
  all_groups: 'All Groups',
  delete_device_group_info: 'Are you sure to delete this device group?',
  saving: 'Saving',
  saved: 'Saved',
  define_the_product: 'Define The Product',
  define_the_product_desc: 'A collection of devices with the same capabilities or characteristics is called a product',
  register_the_device: 'Register The Device',
  register_the_device_desc: 'Create an identity for the device and enroll the device to the platform before you can manage the device',
  access_the_device: 'Access The Device',
  access_the_device_desc: 'A variety of access methods and access scenarios, access devices to support data escalation, management control and so on',
  create_a_data_pipeline: 'Create A Data Pipeline',
  create_a_data_pipeline_desc: 'Clean and preprocess edge and cloud data through data pipelines',
  configure_the_storage: 'Configure The Storage',
  configure_the_storage_desc: 'Complete the data policy configuration and divide the data into different storage according to effectiveness',
  analyze_the_data: 'Analyze The Data',
  analyze_the_data_desc: 'The data after cleaning filtering are analyzed, sometimes in sequence, in real time and so on',
  process_guidance: 'Process Guidance',
  latest_news: 'Latest News',
  edge_cloud_rules: 'Edge Rules',
  edge_cloud_rule: 'Edge Rule',
  edge_cloud_rule_forwarding: 'Data Forwarding',
  edge_forwarding: 'Edge Data Forwarding',
  rule_name: 'Rule Name',
  please_select: 'Please select a {type} name',
  total_products: 'Total Products',
  total_devices: 'Total Devices',
  chart_graph: 'Charts',
  online_devices: 'Online Devices',
  offline_devices: 'Offline Devices',
  deactivated_devices: 'Deactivated Devices',
  used: 'Used',
  free: 'Free',
  product_unit: 'units',
  device_unit: 'units',
  report_content: 'Report Content',
  mqtt_address: 'MQTT Address',
  output_type: 'Output Type',
  set_datasource: 'Set Datasource',
  set_output: 'Set Output',
  old_style: 'Old Style',
  new_style: 'New Style',
  keywords: 'Keywords',
  extension_config_tip:
    'The current device does not have extension information set, first set up the device extension information, which is used to configure the mapping relationship between the device access gateway and the device model definition.',
  every_times: 'Every {time} ',
  update_extension_config_sucessfully: 'Update extension config sucessfully',
  device_groups: 'Device Groups',
  more_kubeiot: 'More',
  discard: 'Discard',
  run: 'Run',
  view_switch: 'View Switch',
  ex_co_modules: 'Expand or Collapse all modules',
  stream_status: 'Rule Status',
  create_forwarding_rule: 'Create Forwarding Rule',
  set_cleaning_rule: 'Set Cleaning Rule',
  set_forwarding_target: 'Set Forwarding Target',
  run_rule: 'Run Rule',
  create_stream: 'Rule',
  baudrate: 'BaudRate',
  worker_id: 'WorkerID',
  data_bits: 'DataBits',
  parity: 'Parity Check',
  stop_bit: 'StopBits',
  register: 'Register Type',
  CoilRegister: 'CoilRegister',
  DiscreteInputRegister: 'DiscreteInputRegister',
  InputRegister: 'InputRegister',
  HoldingRegister: 'Register Address',
  offset: 'Register Address',
  quantity: 'Quantity',
  endianness: 'Endianness',
  timeout: 'Timeout',
  BigEndian: 'BigEndian',
  BigEndianSwap: 'BigEndianSwap',
  LittleEndian: 'LittleEndian',
  LittleEndianSwap: 'LittleEndianSwap',
  device_extension_config: 'Device Extension Config',
  property_extension_config: 'Property Extension Config',
  command_extension_config: 'Command Extension Config',
  event: 'Event',
  no_config: 'No cofigs',
  already_config: 'Already Configs',
  request_data_type: 'Data Type',
  request_item_type: 'Item Type',
  device_protocol: 'Device Protocol',
  inmmediate_delivery: 'Inmmediate Delivery',
  unbinding: 'Unbind',
  report_channel: 'Devices report messages over the MQTT channel that need to be sent to the specified topic',
  report_format: 'Report the news topic format: /devices/device_id/sys/properties/report',
  saved_successfully: 'Saved successfully',
  run_stream: 'Run Rule',
  stop_stream: 'Stop Rule',
  update_stream: 'Rule',

  // =======================           AutoIoTSuite        =======================
  synchronization: 'Synchronization'
};

export default en_US;
